<template>
  <div id="insightsManagers2">
    <div class="margin-subpages">
      <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style" @change="handleTeams"
      :class="[ blurMode ?  'blurelement': '' ]">
        <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown" key="all" :label="`All Teams (${$utils(
        'addCommasInNumber',
        optionsTeam.length
      )})`" value="all"></el-option>
        <el-option class="text-dropdown"
        :class="[ blurMode ?  'blurelement': '' ]" 
        v-for="item in optionsTeam" :key="item.key" :label="item.name"
          :value="item.key"></el-option>
      </el-select>
      <div id="activityOverview">
        <div class="mt-32 flex-mid">
          <div class="fs-18 flex-center mr-auto">
            <span class="fw-700 pt-4">{{
        $t("insights.ACTIVITY_OVERVIEW")
      }}</span>
            <!-- <span class="span-last-30-day">
              •&nbsp;&nbsp;Last 30 days updated in real-time
            </span> -->
          </div>
          <img @click="settingsStatus = !settingsStatus" src="../../assets/images/insights/ic_settings@2x.png" alt=""
            class="cursor-pointer" style="height: 32px; width: 32px" />
        </div>

        <div class="report-container mt-14">
          <div>
            <div class="text-header">Manager Responsiveness</div>
            <div class="box-card-border responsiveness-card">
              <!-- Compact Trend Chart integrated into the card -->
              <div v-if="!loadingManager && managerTrendData.datasets && managerTrendData.datasets.length > 0" class="responsiveness-integrated-chart">
                <div class="compact-chart-container">
                  <canvas ref="responsivenessTrendChart"></canvas>
                </div>
                <div class="chart-footer-info">
                  <span v-if="managerTrendData.summary" class="trend-badge-inline">
                    {{ managerTrendData.summary.totalManagers }} managers · {{ managerTrendData.summary.totalWeeks }} weeks
                  </span>
                  <span class="flex-center router-link" @click="anchorTableLink">
                    <span>Manager Activity Details</span>
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </div>
              <!-- Loading skeleton -->
              <div v-else-if="loadingManager" class="responsiveness-integrated-chart">
                <div class="skeleton-chart-compact"></div>
                <div class="chart-footer-info">
                  <div class="text-skeleton" style="width: 120px;">&nbsp;</div>
                </div>
              </div>
              <!-- Fallback to original metrics if no trend data -->
              <div v-else>
                <div class="grid-3-auto">
                  <div class="status-box" style="background-color: #66bb6a1a">
                    <div class="title">Responsive</div>
                    <div class="flex-center mt-8">
                      <img class="circle" :src="$utils('icons', 'User_status_Active_24px')"
                        alt="icons_User_status_Active_24px" />
                      <div class="ml-6">
                        <span class="fs-16 fw-700">{{ activeOverview.active }}</span>
                        <span class="fs-11 fw-700" :class="`text-${activeOverview.compareactive === 0 ? 'gray' : activeOverview.compareactive > 0 ? 'green' : 'red'}`">
                          {{ activeOverview.compareactive >= 0 ? `+${activeOverview.compareactive}` : `${activeOverview.compareactive}` }}%
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="status-box" style="background-color: #fbc02d1a">
                    <div class="title">Moderate</div>
                    <div class="flex-center mt-8">
                      <img class="circle" :src="$utils('icons', 'User_status_Passive_24px')"
                        alt="icons_User_status_Passive_24px" />
                      <div class="ml-6">
                        <span class="fs-16 fw-700">{{ activeOverview.passive }}</span>
                        <span class="fs-11 fw-700" :class="`text-${activeOverview.comparepassive === 0 ? 'gray' : activeOverview.comparepassive > 0 ? 'red' : 'green'}`">
                          {{ activeOverview.comparepassive >= 0 ? `+${activeOverview.comparepassive}` : `${activeOverview.comparepassive}` }}%
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="status-box" style="background-color: #f443361a">
                    <div class="title">Minimal</div>
                    <div class="flex-center mt-8">
                      <img class="circle" :src="$utils('icons', 'User_status_Inactive_24px@2x')"
                        alt="icons_User_status_Inactive_24px@2x" />
                      <div class="ml-6">
                        <span class="fs-16 fw-700">{{ activeOverview.inactive }}</span>
                        <span class="fs-11 fw-700" :class="`text-${activeOverview.compareinactive === 0 ? 'gray' : activeOverview.compareinactive > 0 ? 'red' : 'green'}`">
                          {{ activeOverview.compareinactive >= 0 ? `+${activeOverview.compareinactive}` : `${activeOverview.compareinactive}` }}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-8">
                  <span class="fs-12 opa-06">Managers play a central role in linking your objectives to actions and
                    results.</span>
                  <span class="flex-center router-link mt-4" @click="anchorTableLink">
                    <span>Manager Activity Details</span>
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </div>
              <!-- <div class="line-break mt-12"></div> -->
              <!-- <div class="grid-2-50 mt-20">
                <div class="mr-6">
                  <div class="flex-center">
                    <div class="title">Proactivity Rating</div>
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          Hover over the score below to see detailed breakdown and improvement suggestions.
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                        alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                  <div v-if="loadingManagerInsight" class="flex-center opa-06 mt-6">
                    <div class="score-box flex-mid"></div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar opa-04">
                        <div class="value"></div>
                      </div>
                      <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-6">
                    <div class="score-box flex-mid" :class="`${insight.proactivityRatingValue >
                      benchmarkProactivityRatingScore
                      ? 'green'
                      : insight.proactivityRatingValue < 40
                        ? 'red'
                        : 'yellow'
                      }`">
                      {{ insight.proactivityRatingValue }}
                    </div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar">
                        <div class="value" :style="`width: ${benchmarkBar(
                          insight.proactivityRatingValue
                        )}px; ${insight.proactivityRatingValue >=
                          benchmarkProactivityRatingScore
                          ? ''
                          : insight.proactivityRatingValue < 40
                            ? ' background-color: #F44336;'
                            : ' background-color: #FBC02D;'
                          }`"></div>
                        <div class="value benchmark" :style="`width: ${benchmarkBar(
                          benchmarkProactivityRatingScore
                        )}px;`"></div>
                      </div>
                      <div class="flex-center fs-10 fw-700 mt-2 opa-04">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="loadingManager" class="fs-12 mt-4">
                    <div class="text-skeleton opa-04" style="width: 80px">
                      &nbsp;
                    </div>
                  </div>
                  <div v-else class="fs-12 mt-4">
                    <div class="fw-900 text-green" v-if="insight.proactivityRatingValue ==
                      benchmarkProactivityRatingScore
                      ">
                      {{
                        insight.proactivityRatingValue -
                        benchmarkProactivityRatingScore
                      }}
                      {{ $t("insights.points") }}
                      <span class="fc-000000 fw-400">
                        {{ $t("insights.above_benchmark") }} ({{
                          benchmarkProactivityRatingScore
                        }})</span>
                    </div>
                    <div v-else>
                      <span class="fw-900 text-green" v-if="insight.proactivityRatingValue >
                          benchmarkProactivityRatingScore
                          ">{{
      insight.proactivityRatingValue -
      benchmarkProactivityRatingScore
    }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
                          benchmarkProactivityRatingScore }})</span>
                      </span>
                      <span v-else class="fw-900 text-red">{{
                        (insight.proactivityRatingValue -
                          benchmarkProactivityRatingScore) *
                        -1
                      }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
                          benchmarkProactivityRatingScore }})</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="ml-6">
                  <div class="flex-center">
                    <div class="title">Psychological Safety Rating</div>
                    <button class="breakdown-info-btn" @click="openPsychologicalModal()" title="View detailed breakdown">
                      <i class="el-icon-info"></i>
                    </button>


                  </div>
                  <div v-if="loadingManagerOverview" class="flex-center opa-06 mt-6">
                    <div class="score-box flex-mid"></div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar opa-04">
                        <div class="value"></div>
                      </div>
                      <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-6">
                    <div class="score-box flex-mid" :class="`${_activeOverview.psychologicalRatingValue >
                      benchmarkPsychologicalRatingScore
                      ? 'green'
                      : _activeOverview.psychologicalRatingValue < 50
                        ? 'red'
                        : 'yellow'
                      }`">
                      {{ _activeOverview.psychologicalRatingValue }}
                    </div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar">
                        <div class="value" :style="`width: ${benchmarkBar(
                          _activeOverview.psychologicalRatingValue
                        )}px; ${_activeOverview.psychologicalRatingValue >
                          benchmarkPsychologicalRatingScore
                          ? ''
                          : _activeOverview.psychologicalRatingValue < 50
                            ? ' background-color: #F44336;'
                            : ' background-color: #FBC02D;'
                          }`"></div>
                        <div class="value benchmark" :style="`width: ${benchmarkBar(
                          benchmarkPsychologicalRatingScore
                        )}px;`"></div>
                      </div>
                      <div class="flex-center opa-04 fs-10 fw-700 mt-2 opa-04'">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="loadingManagerOverview" class="fs-12 mt-4">
                    <div class="text-skeleton opa-04" style="width: 80px">
                      &nbsp;
                    </div>
                  </div>
                  <div v-else class="fs-12 mt-4">
                    <div v-if="_activeOverview.psychologicalRatingValue ==
                      benchmarkPsychologicalRatingScore
                      ">
                      <span class="fc-000000 fw-400">
                        {{ $t("insights.point_same_benchmark") }} ({{
                          benchmarkPsychologicalRatingScore
                        }})</span>
                    </div>
                    <div v-else>
                      <span class="fw-900 text-green" v-if="_activeOverview.psychologicalRatingValue >
                          benchmarkPsychologicalRatingScore
                          ">{{
      _activeOverview.psychologicalRatingValue -
      benchmarkPsychologicalRatingScore
    }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
                          benchmarkPsychologicalRatingScore }})</span>
                      </span>
                      <span v-else class="fw-900 text-red">{{
                        (_activeOverview.psychologicalRatingValue -
                          benchmarkPsychologicalRatingScore) *
                        -1
                      }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
                          benchmarkPsychologicalRatingScore }})</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div> -->
              
            </div>
          </div>
          <div class="ml-16">
            <div class="text-header">Performance Metrics</div>
            <div class="box-card-border">
              <div class="fs-12">

                <div class="grid-2-50 " style="grid-template-columns: 52% 48%">
                  <div>
                    <div class="title mt-16">
                      {{ "Feedback Rate" }}
                    </div>
                    <div class="mt-8">
                      <div v-if="loadingManagerOverview" class="flex-center">
                        <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                          &nbsp;
                        </div>
                        <div class="text-skeleton ml-6" style="width: 40px">
                          &nbsp;
                        </div>
                      </div>
                      <div v-else class="flex-center mt-6">
                        <img :src="$utils('icons', 'Open-ended_fb_rate-blue-32x32')"
                          alt="icons_Open-ended_fb_rate-blue-32x32" style="width: 32px" />
                        <div class="fs-16 fw-700 ml-6">
                          {{
        `${_activeOverview.openEndedFeedback.openEndedFeedback}%`
      }}
                        </div>
                        <div v-if="_activeOverview.openEndedFeedback.compare != 0" :class="`label-change ${_activeOverview.openEndedFeedback.compare > 0
        ? 'text-green'
        : 'text-red'
        }`">
                          {{
        _activeOverview.openEndedFeedback.compare > 0
          ? `+${_activeOverview.openEndedFeedback.compare}`
          : `${_activeOverview.openEndedFeedback.compare}`
      }}
                          pts
                        </div>
                        <div v-else :class="`label-change fc-6A6A6A`">
                          +{{ _activeOverview.openEndedFeedback.compare }} pts
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="title mt-16">Reply Rate</div>
                    <div v-if="loadingManagerOverview" class="flex-center mt-6">
                      <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                        &nbsp;
                      </div>
                      <div class="text-skeleton opa-08 ml-6" style="width: 40px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <img class="gray-icon-32" :src="$utils('icons', 'Reply_rate-blue-32x32')"
                        alt="icons_Reply_rate-blue-32x32" />
                      <div class="fs-16 fw-700 ml-6">
                        {{ insight["insight"].feedback.thirty }}%
                      </div>
                      <div :class="`label-change ${insight.insight.feedback.compare >= 0 ? 'text-green' : 'text-red'
        }`">
                        {{
        insight["insight"].feedback.compare >= 0
          ? `+${insight["insight"].feedback.compare}`
          : `${insight["insight"].feedback.compare}`
      }}
                        pts
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 
                <div class="grid-2-50 mt-16" style="grid-template-columns: 56% 48%">
                  <div>
                    <div class="title">Response (days)</div>
                    <div v-if="loadingresponse" class="flex-center mt-6">
                      <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                        &nbsp;
                      </div>
                      <div class="text-skeleton opa-08 ml-6" style="width: 40px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <img class="gray-icon-32" :src="$utils('icons', 'ic_response_time')" alt="ic_response_time" />
                      <div class="fs-16 fw-700 ml-6">
                        {{ insightresponse.response }}
                      </div>
                      <div :class="`label-change ${insightresponse.compare >= 0 ? 'text-red' : 'text-green'
                        }`">
                        {{
                          insightresponse.compare >= 0
                          ? `+${insightresponse.compare}`
                          : `${insightresponse.compare}`
                        }}

                      </div>
                      <div v-else :class="`label-change fc-6A6A6A`">
                        {{ `+${activeOverview["insight"].feedback.compare}` }}
                        pts
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="title">Reply Quality</div>
                    <div v-if="loadingManagerOverview" class="flex-center mt-6">
                      <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                        &nbsp;
                      </div>
                      <div class="text-skeleton opa-08 ml-6" style="width: 40px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <img class="gray-icon-32" :src="$utils('icons', 'Reply_quality-blue-32x32')"
                        alt="icons_Reply_quality-blue-32x32" />
                      <div class="fs-16 fw-700 ml-6">
                        {{ _activeOverview["replyQuality"].replyQuality }}
                      </div>
                      <div v-if="_activeOverview['replyQuality'].compare != 0" :class="`label-change ${_activeOverview['replyQuality'].compare > 0
                        ? 'text-green'
                        : 'text-red'
                        }`">
                        {{
                          _activeOverview["replyQuality"].compare > 0
                          ? `+${_activeOverview["replyQuality"].compare}`
                          : `${_activeOverview["replyQuality"].compare}`
                        }}%
                      </div>
                      <div v-else :class="`label-change fc-6A6A6A`">
                        {{ `+${_activeOverview["replyQuality"].compare}` }}%
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="line-break mt-24"></div>

                <div v-if="loadingManagerInsight" class="fs-12 text-skeleton mt-16"
                  style="width: 110px; background: #6c30cc10">
                  &nbsp;
                </div>
                <div v-else class="mt-14">
                  <span v-if="isPerformanceBoostEnabled" class="flex-center router-link mt-20" @click="routerLink('performance', 'overview')">
                    <span>Performance Boosts On Track</span>
                    <i class="el-icon-arrow-right"></i>
                  </span>
                  <span v-else class="flex-center mt-20">
                    <span class="opa-06">Performance Boosts On Track</span>
                  </span>
                </div>
                <div>
                  <div v-if="loadingManagerInsight" class="flex-center mt-6">
                    <div class="image-skeleton opa-04" style="width: 32px; height: 32px; border-radius: 32px">
                      &nbsp;
                    </div>
                    <div class="text-skeleton opa-06 ml-6" style="width: 40px">
                      &nbsp;
                    </div>
                  </div>
                  <div v-else-if="isPerformanceBoostEnabled">
                    <div class="flex-center mt-12">
                      <img class="gray-icon-32" :src="$utils('icons', 'Top_performer-blue-32x32')"
                        alt="icons_Top_performer-blue-32x32" />
                      <div class="fs-16 fw-700 ml-6">
                        {{getReviewCompleted()}}%
                      </div>
                    </div>
                    <div class="thin-progress-bar mt-16">
                      <div class="progress-fill" :style="{ width: getReviewCompleted() + '%' }"></div>
                    </div>
                    <!-- <div v-if="insight.performerRecognition
                          .compareTopPerformerRecognition != 0
                        " :class="`label-change ${insight.performerRecognition
      .compareTopPerformerRecognition > 0
      ? 'text-green'
      : 'text-red'
      }`">
                      {{
                        insight.performerRecognition
                          .compareTopPerformerRecognition > 0
                        ? `+${insight.performerRecognition.compareTopPerformerRecognition}`
                        : `${insight.performerRecognition.compareTopPerformerRecognition}`
                      }}
                      pts
                    </div>
                    <div v-else-if="!loadingManagerInsight" :class="`label-change fc-6A6A6A`">
                      +{{
                        insight.performerRecognition
                          .compareTopPerformerRecognition
                      }}
                      pts
                    </div> -->
                  </div>
                  <div v-else class="mt-12">
                    <div class="fs-16 fw-700 opa-04">N/A</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-16">
            <div class="text-header">Insights & Nudges</div>
            <div class="box-card-border fs-12">
              <div class="title mt-4">Daily Insights</div>
              <div class="mt-6">
                <div v-if="loadingManagerInsight" class="bar-contariner flex-center opa-06">
                  <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="bar-contariner flex-center">
                  <div v-for="(value, index) in arrayToPercentage(
        insight['insight'].report_daily_boss.thirty
      )" :key="index + '_bar_adoption'" :class="`bar ${value}`"></div>
                  <div class="fs-16 fw-700 ml-6">
                    {{ insight["insight"].report_daily_boss.thirty }}%
                  </div>
                  <div v-if="insight['insight'].report_daily_boss.compare != 0
        " :class="`label-change ${0 > insight['insight'].report_daily_boss.compare
        ? 'text-red'
        : 'text-green'
        }`">
                    {{
        insight["insight"].report_daily_boss.compare
          ? insight["insight"].report_daily_boss.compare >
            0
            ? `+${insight["insight"].report_daily_boss.compare}`
            : insight["insight"].report_daily_boss.compare
          : 0
      }}%
                  </div>

                  <div v-else class="label-change fc-6A6A6A">
                    +{{ dailyInsightsChange }}%
                  </div>
                </div>
              </div>
              <div class="title mt-16">Weekly Insights</div>
              <div class="mt-6">
                <div v-if="loadingManagerInsight" class="bar-contariner flex-center opa-06">
                  <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="bar-contariner flex-center mb-13">
                  <div v-for="(value, index) in arrayToPercentage(
        insight.insight.report_weekly_boss.thirty
      )" :key="index + '_bar_adoption'" :class="`bar ${value}`"></div>
                  <div class="fs-16 fw-700 ml-6">
                    {{ insight["insight"].report_weekly_boss.thirty }}%
                  </div>
                  <div v-if="weeklyInsightsChange != 0" :class="`label-change ${0 > insight['insight'].report_weekly_boss.compare
        ? 'text-red'
        : 'text-green'
        }`">
                    {{
        insight["insight"].report_weekly_boss.compare
          ? insight["insight"].report_weekly_boss.compare >
            0
            ? `+${insight["insight"].report_weekly_boss.compare}`
            : insight["insight"].report_weekly_boss.compare
          : 0
      }}%
                  </div>

                  <div v-else :class="`label-change fc-6A6A6A`">
                    +{{ weeklyInsightsChange }}%
                  </div>
                </div>
              </div>
              
              <!-- Action Items Summary -->
              <div class="line-break mt-4"></div>
              <el-tooltip placement="right" effect="dark">
                <div slot="content" style="max-width: 280px;">
                  <div style="font-weight: 600; margin-bottom: 4px;">Coaching Suggestions</div>
                  <div>AI-generated action items sent to managers in their weekly reports over the past 4 weeks. These personalized recommendations help managers improve team engagement and performance.</div>
                </div>
                <div class="coaching-suggestions-content">
                  <div class="title mt-16">Coaching Suggestions</div>
                  <div class="mt-6">
                    <div v-if="loadingManagerTodos" class="flex-center">
                      <div class="image-skeleton opa-04" style="width: 32px; height: 32px; border-radius: 32px">&nbsp;</div>
                      <div class="text-skeleton opa-06 ml-6" style="width: 60px">&nbsp;</div>
                    </div>
                    <div v-else class="flex-center">
                      <div class="action-items-icon-wrapper">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 11l3 3L22 4"/>
                          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                        </svg>
                      </div>
                      <div class="ml-6">
                        <span class="fs-16 fw-700">{{ actionItemsSummary.totalItems }}</span>
                        <span class="fs-11 fc-909399 ml-4">items</span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tooltip>
              <!-- <div class="line-break mt-14"></div> -->
              <!-- <div v-if="loadingManagerNudges" class="fs-12 text-skeleton mt-16"
                style="width: 40px; background: #6c30cc10">
                &nbsp;
              </div>
              <div v-else class="mt-14">
                <span class="flex-center router-link mt-4" @click="routerLink('sparks', 'nudges')">
                  <span>Nudges</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>

              <div>
                <div v-if="loadingManagerNudges" class="flex-center mt-6">
                  <div class="image-skeleton opa-04" style="width: 32px; height: 32px; border-radius: 32px">
                    &nbsp;
                  </div>
                  <div class="text-skeleton opa-06 ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="flex-center mt-6">
                  <img class="gray-icon-32" :src="$utils('icons', 'nudges-blue-32x32')" alt="icons_nudges-blue-32x32" />
                  <div class="fs-16 fw-700 ml-6">
                    {{ this.$utils("addCommasInNumber", nudges) }}
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="report-container mt-14">
          <div class="box-card-border" style="width: 868px">
            <div class="flex-row" style="align-items: center;">
              <div class="progress-wrapper ml-24" style="width: 200px">
                <div class="progress-wrapper">
                  <svg width="135" height="135" viewBox="0 0 26 26">
                    <circle cx="13" cy="13" r="12" fill="none" stroke-width="2" stroke="#E0E0E0"></circle>
                    <circle
                      v-if="_activeOverview && _activeOverview.replyQuality && _activeOverview.replyQuality.replyQuality > 0"
                      cx="13" cy="13" r="12" fill="none" :stroke-width="2"
                      :stroke="getStrokeColor(_activeOverview.replyQuality.replyQuality)" :stroke-dasharray="75.4"
                      :stroke-dashoffset="75.4 - (_activeOverview.replyQuality.replyQuality * 0.754)"
                      transform="rotate(-90 13 13)">
                    </circle>
                  </svg>
                  <div v-if="loadingManagerOverview" class="score-label">
                    <!-- <div class="fw-700 main">Loading...</div> -->
                    <div class="text-skeleton main opa-08" style="width: 52px">
                      &nbsp;
                    </div>
                    <div class="fs-16 fw-500 description">Quality</div>
                  </div>
                  <div v-else class="score-label">
                    <div class="fw-700 main">{{ _activeOverview["replyQuality"] ?
        _activeOverview["replyQuality"].replyQuality : 0 }}</div>
                    <div class="fs-16 fw-500 description">Quality</div>
                  </div>
                </div>


              </div>
              <div style="width: 398px">
                <div style="width: 322px">
                  <canvas ref="QualityChart"></canvas>
                </div>
              </div>
              <div style="width: 245px">
                <div>
                  <div class="mr-6">
                    <div class="flex-center">
                      <div class="title">Proactivity Rating</div>
                      <!-- <el-tooltip class="header-table-tooltip" placement="top">
                        <div slot="content" class="p-5">
                          <div style="max-width: 250px">
                            A measure of how well managers control a situation by
                            causing something to happen rather than responding to
                            it after it has happened.
                          </div>
                        </div>
                        <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                          alt="icons_ic_help_outline-16px" />
                      </el-tooltip> -->
                    </div>
                    <div v-if="loadingManagerInsight" class="flex-center opa-06 mt-6">
                      <div class="score-box flex-mid"></div>
                      <div style="width: 120px">
                        <div class="point-bar opa-04">
                          <div class="value"></div>
                        </div>
                        <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <div class="score-box flex-mid cursor-pointer" :class="`${adjustedProactivityRatingValue >=
        benchmarkProactivityRatingScore
        ? 'green'
        : adjustedProactivityRatingValue < 40
          ? 'red'
          : 'yellow'
                                }`" @click="openProactivityModal()" title="View detailed breakdown">
                        {{ adjustedProactivityRatingValue }}
                      </div>
                      <div class="mt-12" style="width: 120px">
                        <div class="point-bar">
                          <div class="value" :style="`width: ${benchmarkBar(
        adjustedProactivityRatingValue
      )}px; ${adjustedProactivityRatingValue >=
        benchmarkProactivityRatingScore
        ? ''
        : adjustedProactivityRatingValue < 40
          ? ' background-color: #F44336;'
          : ' background-color: #FBC02D;'
        }`"></div>
                          <div class="value benchmark" :style="`width: ${benchmarkBar(
        benchmarkProactivityRatingScore
      )}px;`"></div>
                        </div>
                        <div class="flex-center fs-10 fw-700 mt-2 opa-04">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="loadingManager" class="fs-12 mt-4">
                      <div class="text-skeleton opa-04" style="width: 80px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="fs-12 mt-4">
                      <div class="fw-900 text-green" v-if="adjustedProactivityRatingValue ==
        benchmarkProactivityRatingScore
        ">
                        {{
        adjustedProactivityRatingValue -
        benchmarkProactivityRatingScore
      }}
                        {{ $t("insights.points") }}
                        <span class="fc-000000 fw-400">
                          {{ $t("insights.above_benchmark") }} ({{
        benchmarkProactivityRatingScore
      }})</span>
                      </div>
                      <div v-else>
                        <span class="fw-900 text-green" v-if="adjustedProactivityRatingValue >
        benchmarkProactivityRatingScore
        ">{{
        adjustedProactivityRatingValue -
        benchmarkProactivityRatingScore
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
        benchmarkProactivityRatingScore }})</span>
                        </span>
                        <span v-else class="fw-900 text-red">{{
        (adjustedProactivityRatingValue -
          benchmarkProactivityRatingScore) *
        -1
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
        benchmarkProactivityRatingScore }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="flex-center mt-13">
                      <div class="title">Psychological Safety Rating</div>
                      <!-- <el-tooltip class="header-table-tooltip" placement="top">
                        <div slot="content" class="p-5">
                          <div style="max-width: 250px">
                            Hover over the score below to see detailed breakdown and improvement suggestions.
                          </div>
                        </div>
                        <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                          alt="icons_ic_help_outline-16px" />
                      </el-tooltip> -->
                    </div>
                    <div v-if="loadingManagerOverview" class="flex-center opa-06 mt-6">
                      <div class="score-box flex-mid"></div>
                      <div class="mt-12" style="width: 120px">
                        <div class="point-bar opa-04">
                          <div class="value"></div>
                        </div>
                        <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <div class="score-box flex-mid cursor-pointer" :class="`${_activeOverview.psychologicalRatingValue >=
        benchmarkPsychologicalRatingScore
        ? 'green'
        : _activeOverview.psychologicalRatingValue < 50
          ? 'red'
          : 'yellow'
        }`" @click="openPsychologicalModal()" title="View detailed breakdown">
                        {{ _activeOverview.psychologicalRatingValue }}
                      </div>
                      <div class="mt-12" style="width: 120px">
                        <div class="point-bar">
                          <div class="value" :style="`width: ${benchmarkBar(
        _activeOverview.psychologicalRatingValue
      )}px; ${_activeOverview.psychologicalRatingValue >
        benchmarkPsychologicalRatingScore
        ? ''
        : _activeOverview.psychologicalRatingValue < 50
          ? ' background-color: #F44336;'
          : ' background-color: #FBC02D;'
        }`"></div>
                          <div class="value benchmark" :style="`width: ${benchmarkBar(
        benchmarkPsychologicalRatingScore
      )}px;`"></div>
                        </div>
                        <div class="flex-center opa-04 fs-10 fw-700 mt-2 opa-04'">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="loadingManagerOverview" class="fs-12 mt-4">
                      <div class="text-skeleton opa-04" style="width: 80px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="fs-12 mt-4">
                      <div v-if="_activeOverview.psychologicalRatingValue ==
        benchmarkPsychologicalRatingScore
        ">
                        <span class="fc-000000 fw-400">
                          {{ $t("insights.point_same_benchmark") }} ({{
        benchmarkPsychologicalRatingScore
      }})</span>
                      </div>
                      <div v-else>
                        <span class="fw-900 text-green" v-if="_activeOverview.psychologicalRatingValue >
        benchmarkPsychologicalRatingScore
        ">{{
        _activeOverview.psychologicalRatingValue -
        benchmarkPsychologicalRatingScore
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
        benchmarkPsychologicalRatingScore }})</span>
                        </span>
                        <span v-else class="fw-900 text-red">{{
        (_activeOverview.psychologicalRatingValue -
          benchmarkPsychologicalRatingScore) *
        -1
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
        benchmarkPsychologicalRatingScore }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal-preview-user v-if="modalPreviewDataStatus" :modalMemberData="modalMemberData" :userDetail="userDetail"
        :showingModal="modalPreviewDataStatus" :passProfileToRelationship="passProfileToRelationship"
        @closed="closedModal"></modal-preview-user>
      <div id="byManager">
        <div class="flex-row-between">
          <div>
            <div class="mt-30 fs-18 fw-700">Individual Manager Analysis</div>
            <div class="fc-747474 fs-13 mt-6">
              {{ $t("insights.Managers_activity_in") }}
            </div>
          </div>
          <div class="flex-center mt-30" id="menuDropdown">

            <el-menu class="el-menu-demo menu-option-style" mode="horizontal" style="height: 40px;">
              <el-submenu index="0" style="width: 220px; height: 40px;">
                <template slot="title">
                  <span class="txtOption1" style="height: 40px;">{{ selectChart }}</span>
                </template>
                <el-menu-item index="1" @click="changeChart('vs Reply Quality')"
                  style="font-size: 14px; width: 220px">vs Reply Quality
                </el-menu-item>
                <el-menu-item index="2" @click="changeChart('vs Open Rate')" style="font-size: 14px; width: 220px">vs
                  Open Rate
                </el-menu-item>

              </el-submenu>
            </el-menu>
          </div>
        </div>

        <div class="flex-mid" style="height: 254px" v-if="loadingManager">
          <loading-even></loading-even>
        </div>
        <div v-else style="height: 0px; width: 0px">
          <div class="fs-11 fw-500 opa-07 site-text">
            {{ selectChart }}
          </div>
        </div>
        <div v-if="!loadingManager" class="chart-container">
          <div class="center">
            <div class="flex-mid">
              <img src="../../assets/images/insights/ic_bubble_size@2x.png" alt="" style="height: 24px; width: 24px" />
              <div class="center fs-11 fw-500 opa-07 ml-4">
                {{ $t("insights.Team_Size") }}
              </div>
            </div>
          </div>
          <div style="height: 190px">
            <canvas ref="managerChart"></canvas>
          </div>
          <div class="center fs-11 fw-500 opa-07">
            {{ $t("insights.Feedback_Reply_Rate") }}
          </div>
        </div>
      </div>
      <div id="scorecard" class="fs-18 fw-700 mt-40">Manager Scorecard</div>
      <div class="fs-13 fc-747474 mt-6">This scorecard provides an overview of the key activities and performance
        metrics for
        managers, focusing on their interactions with direct reports. It helps understand how well managers role model
        key
        behaviors, drive performance, and engage their teams.</div>

      <div ref="table_anchor" id="table" class="mt-24">
        <div class="flex" style="margin-bottom: 10px; margin-right: 10px">
          <div class="mr-auto">
            <el-input class="input-style" style="height: 40px" autosize :placeholder="$t('global.Search')"
              @keyup.native="typeingSearchManager" v-model="inputSearch"></el-input>
          </div>
          
          <!-- Manager Class Filter -->
          <div style="width: 220px; margin-right: 10px;" class="flex">
            <el-select v-model="selectedClass" class="input-style" placeholder="Performance Group" style="width: 160px;">
              <el-option label="All Performance Groups" value="all" />
              <el-option label="Elite Managers" value="elite" />
              <el-option label="High Performers" value="effective" />
              <el-option label="Rising Stars" value="rising" />
              <el-option label="Feedback Champions" value="fb_champ" />
              <el-option label="At-Risk Managers" value="risk" />
              <el-option label="Ghost Managers" value="ghost" />
              <!-- <el-option label="New Managers (<6m)" value="newmgr" /> -->
            </el-select>
          </div>
          
          <div style="width: 220px; margin-right: 52px" id="menuDropdownType" class="flex">
            <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
              <el-submenu index="0" style="width: 220px">
                <template slot="title">
                  <span class="txtOption" v-if="selectStatus == 'all'">{{ $t("insights.All_Activity_Types") }}
                    {{
        activeOverview && activeOverview.all
          ? "(" + activeOverview.all + ")"
          : ""
      }}</span>
                  <span class="txtOption" v-if="selectStatus == 'active'">{{ "Responsive" }}
                    {{
        activeOverview && activeOverview.active
          ? "(" + activeOverview.active + ")"
          : ""
      }}</span>
                  <span class="txtOption" v-if="selectStatus == 'passive'">{{ "Moderate" }}
                    {{
        activeOverview && activeOverview.passive
          ? "(" + activeOverview.passive + ")"
          : ""
      }}</span>
                  <span class="txtOption" v-if="selectStatus == 'inactive'">{{ "Minimal" }}
                    {{
        activeOverview && activeOverview.inactive
          ? "(" + activeOverview.inactive + ")"
          : ""
      }}</span>
                </template>
                <el-menu-item v-if="selectStatus !== 'all'" index="1" @click="sortBy('all')"
                  style="font-size: 14px; width: 220px">{{ $t("insights.All_Activity_Types") }}
                  {{
        activeOverview && activeOverview.all
          ? "(" + activeOverview.all + ")"
          : ""
      }}</el-menu-item>
                <el-menu-item v-if="selectStatus !== 'active'" index="2" @click="sortBy('active')"
                  style="font-size: 14px; width: 220px">{{ "Responsive" }}
                  {{
        activeOverview && activeOverview.active
          ? "(" + activeOverview.active + ")"
          : ""
      }}</el-menu-item>
                <el-menu-item v-if="selectStatus !== 'passive'" index="3" @click="sortBy('passive')"
                  style="font-size: 14px; width: 220px">{{ "Moderate" }}
                  {{
        activeOverview && activeOverview.passive
          ? "(" + activeOverview.passive + ")"
          : ""
      }}</el-menu-item>
                <el-menu-item v-if="selectStatus !== 'inactive'" index="4" @click="sortBy('inactive')"
                  style="font-size: 14px; width: 220px">{{ "Minimal" }}
                  {{
        activeOverview && activeOverview.inactive
          ? "(" + activeOverview.inactive + ")"
          : ""
      }}</el-menu-item>
              </el-submenu>
            </el-menu>
            <div class="mt-2 ml-20">
              <div>
          <svg
            @click="exportTable()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
        </div>
            </div>
            <download-progress :active="showSnackbar"></download-progress>
          </div>
        </div>
        
        <!-- Filter Criteria Toolbar - only shows when a class filter is applied -->
        <div v-if="selectedClass !== 'all'" class="filter-criteria-toolbar mt-16 mb-12">
          <div class="flex-center">
            <div class="filter-icon">
              <i class="el-icon-info"></i>
            </div>
            <div class="filter-details">
              <div class="filter-title">{{ selectedClass === 'elite' ? 'Elite Managers' : 
                selectedClass === 'effective' ? 'High Performers' :
                selectedClass === 'rising' ? 'Rising Stars' : 
                selectedClass === 'fb_champ' ? 'Feedback Champions' : 
                selectedClass === 'risk' ? 'At-Risk Managers' : 
                selectedClass === 'ghost' ? 'Ghost Managers' : 
                selectedClass === 'newmgr' ? 'New Managers (<6m)' : 'Custom Filter' }}
              </div>
              <div class="filter-description">
                <span v-if="selectedClass === 'elite' && isPerformanceBoostEnabled">
                  Managers with all three metrics in the exceptional range: high reply rate (≥80%),
                  high boosters on track (≥80%), and high DEBI score (≥60).
                </span>
                <span v-else-if="selectedClass === 'elite'">
                  Managers with exceptional metrics: high reply rate (≥80%) and high DEBI score (≥60).
                </span>
                <span v-else-if="selectedClass === 'effective' && isPerformanceBoostEnabled">
                  Managers with strong performance across key areas: good reply rate (≥60%),
                  strong boosters on track (≥60%), and good DEBI score (≥50).
                </span>
                <span v-else-if="selectedClass === 'effective'">
                  Managers with strong performance across key areas: good reply rate (≥60%) and good DEBI score (≥50).
                </span>
                <span v-else-if="selectedClass === 'rising' && isPerformanceBoostEnabled">
                  Managers with moderate reply rate (≥40), good boosters on track (≥40%), and solid DEBI scores (≥40%).
                </span>
                <span v-else-if="selectedClass === 'rising'">
                  Managers with moderate reply rate (≥40) and solid DEBI scores (≥40%).
                </span>
                <span v-else-if="selectedClass === 'fb_champ'">
                  Managers who excel at communication: high conversation initiation (≥60%) and high reply rate (≥60%).
                </span>
                <span v-else-if="selectedClass === 'risk'">
                  Managers needing attention: low reply rate (<30%) or low DEBI score (<40).
                </span>
                <span v-else-if="selectedClass === 'ghost' && isPerformanceBoostEnabled">
                  Managers with no activity: 0 conversations initiated, 0 boosters on track, and 0% reply rate.
                </span>
                <span v-else-if="selectedClass === 'ghost'">
                  Managers with no activity: 0 conversations initiated and 0% reply rate.
                </span>
                <span v-else-if="selectedClass === 'newmgr'">
                  Managers with less than 6 months in their current role.
                </span>
              </div>
            </div>
            <el-button type="text" class="edit-criteria-btn" @click="selectedClass = 'all'">
              <i class="el-icon-close"></i>
            </el-button>
          </div>
        </div>
        
        <div class="flex ml-3 mt-28">
          <div style="width: 50px"></div>
          <div style="width: 150px"></div>
          <div style="width: 140px" class="top-title">
            <div>{{ "Leadership" }}</div>
          </div>
          <div style="width: 205px" class="top-title">
            <div>{{ "Performance" }}</div>
          </div>
          <div style="width: 330px" class="top-title">
            <div>{{ "Engagement" }}</div>
          </div>
          <!-- <div style="width: 220px" class="top-title">
            <div>{{ "Engagement" }}</div>
          </div> -->
        </div>


        <div class="flex ml-3 mt-28">
          <div class="fs-11 fw-900" style="width:235px">Manager</div>
          <el-tooltip
            content="Percentage of conversations initiated by this manager with their own manager, demonstrating proactive upward communication"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Conv.<br> Initiated</div>
          </el-tooltip>
          <el-tooltip
            content="Number of peer feedback requests this manager has made for themselves, showing commitment to self-improvement"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Peer <br> Feedback</div>
          </el-tooltip>
          <el-tooltip content="Percentage of performance boosts that are either completed or pending but not overdue"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 ml-24 cursor-pointer" style="text-align: center;width:64px">Boosts <br> On Track
            </div>
          </el-tooltip>
          <el-tooltip content="Overall progress made by direct reports as evaluated in their performance reviews"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Goals <br> Progress</div>
          </el-tooltip>
          <el-tooltip
            content="How well direct reports are contributing to the culture, as evaluated in their performance reviews"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Culture <br> Contr.</div>
          </el-tooltip>
          <el-tooltip content="Percentage of team feedback the manager has responded to in the past 30 days"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 ml-16 cursor-pointer" style="text-align: center;width:82px">Reply <br> Rate</div>
          </el-tooltip>
          <el-tooltip
            content="Percentage of Manager Insights opened from email inbox. Note: May be inaccurate if email tracking is blocked"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Insights <br> Opened</div>
          </el-tooltip>
          <el-tooltip
            content="Dynamic Engagement Behavior Index of the manager's direct reports, indicating the manager's effectiveness in keeping their team engaged"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">DEBI <br> Score</div>
          </el-tooltip>
          <el-tooltip placement="top" effect="dark">
            <div slot="content" style="max-width: 280px;">
              <div style="font-weight: 600; margin-bottom: 4px;">Action Items ({{ actionItemsSummary.totalItems }} total)</div>
              <div>Coaching suggestions from the past 4 weeks, sent to managers in their weekly reports. Managers address these independently - use this view to identify opportunities to offer support.</div>
            </div>
            <div class="fs-11 fw-900 cursor-pointer action-items-header center">
              Action Items ({{ actionItemsSummary.totalItems }})
            </div>
          </el-tooltip>
        </div>

        <div v-if="loadingManager && loadingresponse && loadingManagerOverview" class='flex-mid mt-20'>
          <loading-even></loading-even>
        </div>
        <div v-else-if="noFilterResults" class="flex-center mt-24 mb-24">
          <div class="no-results">
            <div class="fs-16 fw-600">No managers match the "{{ selectedClass === 'elite' ? 'Elite Managers' : 
              selectedClass === 'rising' ? 'Rising Stars' : 
              selectedClass === 'fb_champ' ? 'Feedback Champions' : 
              selectedClass === 'culture' ? 'Culture Builders' : 
              selectedClass === 'balanced' ? 'Balanced Performers' : 
              selectedClass === 'risk' ? 'At-Risk Managers' : 
              selectedClass === 'ghost' ? 'Ghost Managers' : 
              selectedClass === 'newmgr' ? 'New Managers' : selectedClass }}" filter</div>
            <div class="fs-14 mt-8">Try a different filter or select "All Performance Groups" to see all managers</div>
          </div>
        </div>
        <div v-else>
          <!-- new card -->
          <div v-for="(val, index) in filteredManagers" :key="index + 'card'">
            <div class="box-card-table">
              <div class="flex-column ml-12" style=" justify-content: center;min-height: 53px;width:220px;">


                <div>
                  <div class="flex-center cursor-pointer" @click="showPreviewData(val)">
                    <el-tooltip v-if="val.directMember" effect="light" placement="top">
                      <div slot="content" style="max-width: 250px;">
                        <div v-if="val.directMember >= 10" style="font-size: 12px;">
                          <strong style="color: #DC2626;">High Span of Attention ({{ val.directMember }} reports)</strong><br/>
                          Managing 10+ direct reports may reduce effectiveness. Consider restructuring or adding support.
                        </div>
                        <div v-else-if="val.directMember >= 7" style="font-size: 12px;">
                          <strong style="color: #D97706;">Elevated Span of Attention ({{ val.directMember }} reports)</strong><br/>
                          Managing 7-9 direct reports is challenging. Monitor for signs of manager overload.
                        </div>
                        <div v-else-if="val.directMember >= 6" style="font-size: 12px;">
                          <strong style="color: #059669;">Good Span of Attention ({{ val.directMember }} reports)</strong><br/>
                          6-7 direct reports is at the upper end of the optimal range.
                        </div>
                        <div v-else style="font-size: 12px;">
                          <strong style="color: #059669;">Optimal Span of Attention ({{ val.directMember }} reports)</strong><br/>
                          Research shows 5-7 direct reports is most effective for manager and team success.
                        </div>
                      </div>
                      <div v-if="val.profilepic" style="width: 36px" class="profilepic"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <img v-lazy="val.profilepic" :key="val.profilepic" class="imgProfile image-skeleton" />
                        <div class="fs-10 fw-600 report-count" 
                             :class="{ 'report-count-red': val.directMember >= 10, 'report-count-orange': val.directMember >= 7 && val.directMember < 10 }">
                          <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm6 5c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Z"/>
                          </svg>
                          {{ val.directMember }}
                        </div>
                      </div>
                      <div v-else class="profilepic image image-profile-36"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <span class="text-in-image text-in-image-36 flex-mid" style="width: 36px">{{
        val.shortname
      }}</span>
                        <div class="fs-10 fw-600 report-count" 
                             :class="{ 'report-count-red': val.directMember >= 10, 'report-count-orange': val.directMember >= 7 && val.directMember < 10 }">
                          <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm6 5c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Z"/>
                          </svg>
                          {{ val.directMember }}
                        </div>
                      </div>
                    </el-tooltip>
                    <template v-else>
                      <div v-if="val.profilepic" style="width: 36px" class="profilepic"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <img v-lazy="val.profilepic" :key="val.profilepic" class="imgProfile image-skeleton" />
                      </div>
                      <div v-else class="profilepic image image-profile-36"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <span class="text-in-image text-in-image-36 flex-mid" style="width: 36px">{{
        val.shortname
      }}</span>
                      </div>
                    </template>
                    <div class="flex-column ml-12">
                      <span style="color: #000" class="txtName ellipsis fs-14 fw-700"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        {{ val.fullname }}
                      </span>
                      <span class="txtTeam ellipsis fs-13 fw-500 opa-06" style=" color: #000"
                      :class="[ blurMode ?  'blurelement': '' ]">{{
        val.team_name }}</span>
                    </div>
                  </div>

                </div>


              </div>


              <!--Leadership-->
              <div class="flex" style="justify-content: center;width:64px">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Conversations', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].conversations_initiated ? dataQualitybyTeam[val.email].conversations_initiated : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].conversations_initiated ? dataQualitybyTeam[val.email].conversations_initiated : 0 }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;">
                <el-tooltip effect="light" :disabled="false" placement="top">
                  <div slot="content">
                    <div class="peer-feedback-tooltip">
                      <div class="pf-header">Peer Feedback Requests (Last 6 Months)</div>
                      <div v-if="loadingPeerFeedbackHistory" class="pf-loading">
                        <loading-even></loading-even>
                      </div>
                      <div v-else class="pf-heatmap">
                        <div
                          v-for="(monthData, index) in peerFeedbackHistoryDisplay"
                          :key="index"
                          class="pf-month"
                        >
                          <div class="pf-month-label">{{ monthData.label.toUpperCase() }}</div>
                          <div class="pf-circles">
                            <div class="pf-circle" :class="{ 'filled': monthData.count >= 1 }"></div>
                            <div class="pf-circle" :class="{ 'filled': monthData.count >= 2 }"></div>
                          </div>
                          <div class="pf-count">{{ monthData.count }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="cursor-pointer"
                    @mouseover.prevent="showPeerFeedbackHistory(val.email)"
                  >
                    <div
                      :class="`fs-11 fw-600 box ${getBoxstyle('Peer-Feedback', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].peerfeedback ? dataQualitybyTeam[val.email].peerfeedback : 0))}`">
                      {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].peerfeedback ? dataQualitybyTeam[val.email].peerfeedback : 0 }}
                    </div>
                  </div>
                </el-tooltip>
                <div class="section-break ml-24"></div>
              </div>



              <!--Pergormance-->
              <div class="flex" style="justify-content: center;width:64px;">
                <div v-if="isPerformanceBoostEnabled"
                  :class="`fs-11 fw-600 box ${getBoxstyle('Reviews-completed', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.reviewCompleted : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.reviewCompleted : 0 }}%
                </div>
                <div v-else class="fs-11 fw-600 box box-gray">-%</div>
              </div>
              <div class="flex" style="justify-content: center;width:64px">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Goals-Progress', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.GoalsProgress : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.GoalsProgress : 0 }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Culture-Contribution', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.cultuerAdd : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.cultuerAdd : 0 }}%
                </div>
                <div class="section-break ml-24"></div>
              </div>

              <!--Engagement-->

              <div class="flex" style="justify-content: center;">
                <el-tooltip effect="light" placement="top">
                  <div slot="content" class="p-5">
                    <div class="flex-column">
                      <div class="flex-mid" style="min-width: 118px">
                        <div class="fs-11" style="width: 50px">Quality</div>
                        <div class="fs-11" style="width: 50px">Time</div>
                      </div>
                      <div class="flex-mid mt-6" style="min-width: 118px">
                        <div class="fs-11 fw-600" style="width: 50px">{{
        val.feedback == '-' ? '-' : val.feedback_check == 'N' && val.feedback == 0 ? '-' : getReplyQuality(val.email)
      }} /
                          100</div>
                        <div class="fs-11 fw-600" style="width: 50px">{{ val.feedback == '-' ? '-' :
        response[val.email] ? response[val.email].response_day > 0 ?
          (`${response[val.email].response_day} days`) : '< 1 hr' : '< 1 hr' }} </div>
                        </div>


                      </div>

                    </div>
                    <div :class="`fs-11 fw-600 box ${getBoxstyle('Reply-Rate', val.feedback)}`"
                      style="width:62px; cursor: pointer;">
                      <img class="circle" style="width:16px;height:16px;margin-right:6px;"
                        :src="getBoxstyle('Reply-Rate', val.feedback) === 'box-red' ? $utils('icons', 'User_status_Inactive_24px') : getBoxstyle('Reply-Rate', val.feedback) === 'box-yellow' ? $utils('icons', 'User_status_Passive_24px') : $utils('icons', 'User_status_Active_24px')"
                        alt="icons_User_status_Active_24px" />
                      {{ val.feedback }}%
                    </div>


                </el-tooltip>

              </div>
              <div class="flex" style="justify-content: center;width:64px">
                <div :class="`fs-11 fw-600 box ${getBoxstyle('Opened', val.overall_rate)}`" style="">{{ val.overall_rate
                  }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;width:64px">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('DEBI', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].DEBI ? dataQualitybyTeam[val.email].DEBI : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].DEBI ? dataQualitybyTeam[val.email].DEBI : 0 }}
                </div>
              </div>
              <div class="flex" style="width:90px;justify-content:center;">
                <el-popover trigger="hover" placement="left" :open-delay="200" width="400">
                  <div class="todo-tooltip">
                    <!-- All Weeks Section -->
                    <div v-if="getAllTodosByWeek(val.email).length > 0">
                      <div v-for="(week, weekIdx) in getAllTodosByWeek(val.email)" :key="week.weekDate" class="week-section">
                        <div class="week-header">{{ week.weekLabel }}</div>
                        <div v-for="(todo, idx) in week.todos" :key="`${weekIdx}-${idx}`" class="todo-item">
                          <span class="priority-badge" :class="todo.priority ? todo.priority.toLowerCase() : 'medium'">
                            {{ todo.priority || 'Medium' }}
                          </span>
                          <span class="todo-action" v-html="todo.action"></span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="no-todos">No action items available</div>
                    
                    <!-- Critical Areas Section (existing) -->
                    <div class="critical-section" v-if="val.critical_area">
                      <div class="critical-header">Engagement Focus Areas</div>
                      <div class="critical-items">
                        <span v-for="(item, idx) in formattedCriticalAreas(val.critical_area)" :key="idx" class="critical-tag">
                          {{ item }}
                        </span>
                      </div>
                    </div>

                    <!-- Manager ownership note -->
                    <div class="popover-note">
                      Past 4 weeks · Sent to manager weekly
                    </div>
                  </div>
                  
<!-- Display count (trigger element) - Total from past 4 weeks -->
                  <div slot="reference" class="fs-11 fw-600 cursor-pointer todo-count"
                       :class="getTodoCountStyle(val.email)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="todo-icon">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                    {{ getTotalTodoCount(val.email) || '-' }}
                    <span v-if="getTodoTrend(val.email) === 'up'" class="trend-arrow trend-up">↑</span>
                    <span v-else-if="getTodoTrend(val.email) === 'down'" class="trend-arrow trend-down">↓</span>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>

        </div>

        <div class="flex-center pagination mt-10">
          <!-- Only show pagination when viewing all performance groups -->
          <template v-if="selectedClass === 'all'">
            <el-pagination @current-change="handleCurrentManagerChange" :current-page="1" :page-size="10" :pager-count="5"
              layout="prev, pager, next" :total="managerResults"></el-pagination>
            <span class="results-status">
              {{ filteredManagers.length > 10 ? 10 : filteredManagers.length }}
              {{ $t("insights.results_from") }}
              {{ $utils("addCommasInNumber", managerResults) }}
              {{ $t("insights.results") }}
            </span>
          </template>
          <!-- For filtered views, just show the total count -->
          <template v-else>
            <span class="results-status text-center">
              {{ filteredManagers.length }}
              {{ filteredManagers.length === 1 ? 'manager matches' : 'managers match' }} this performance group
            </span>
          </template>
        </div>

      </div>
    </div>
    <div id="coachingModalStatus">
      <el-dialog :visible.sync="coachingModalStatus" width="600px" top="8vh" title="Manager Coaching Interactions">
        <div class="profile">
          <div class="fc-000000 fs-18 fw-700">
            {{
        modalCoachingData && modalCoachingData["user"]
          ? modalCoachingData["user"].firstname +
          " " +
          modalCoachingData["user"].lastname
          : ""
      }}
          </div>
          <div class="fc-626262 fs-14">
            {{
          modalCoachingData && modalCoachingData["user"]
            ? modalCoachingData["user"].team_name
            : ""
        }}
          </div>
        </div>
        <div class="table">
          <el-table :data="modalCoachingData['coaching']"
            :empty-text="loadingCoaching ? ' ' : 'No coaching interactions'" max-height="490" style="width: 100%"
            id="dataTable" class="el-table-thin-scrollbar">
            <el-table-column :label="$t('insights.Date')" width="150">
              <template slot-scope="scope">
                <span class="text-modal">
                  {{ scope.row.date }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('insights.Challenge')" width="180">
              <template slot-scope="scope">
                <span class="text-modal fw-700">{{
        scope.row.challenges
      }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('insights.Score')" width="80" prop="score" sortable header-align="center"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.score >= 0" class="text-modal flex score">
                  <div class="circle-score circle-red" :class="{
        'circle-green': scope.row.score >= scope.row.standard[0],
        'circle-yellow':
          scope.row.score < scope.row.standard[0] &&
          scope.row.score >= scope.row.standard[1],
        'circle-red': scope.row.score,
      }"></div>
                  {{ scope.row.score }}%
                </div>
                <span v-else class="text-modal">-%</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('insights.Status')" width="120" sortable prop="status" header-align="center"
              align="right">
              <template slot-scope="scope">
                <span class="text-modal">{{ scope.row.status }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex-mid" style="height: 254px" v-if="loadingCoaching">
            <loading-even></loading-even>
          </div>
        </div>
      </el-dialog>
    </div>
    <div id="managerClassificationSettingsModalStatus">
      <el-dialog :visible.sync="settingsStatus" :before-close="beforeCloseSettingsModal" width="720px" top="8vh"
        title="Manager Classification Settings">
        <div class="body">
          <div class="active">
            <div class="fs-18 fw-700 fc-000000">
              {{ $t("insights.ACTIVE") }}
            </div>
            <div class="flex">
              <div>
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Insights_Open_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changeActiveInsightsOpen" v-model="managerClassificationSettings.insightsOpen.active
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.max"
                      :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
              <div class="ml-40">
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Feedback_Reply_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changeActiveFeedbackReply" v-model="managerClassificationSettings.feedbackReply.active
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply.max"
                      :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="passive mt-32">
            <div class="fs-18 fw-700 fc-000000">
              {{ $t("insights.PASSIVE") }}
            </div>
            <div class="flex">
              <div>
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Insights_Open_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changePassiveInsightsOpen" v-model="managerClassificationSettings.insightsOpen.passive
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.passiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
              <div class="ml-40">
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Feedback_Reply_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changePassiveFeedbackRepl" v-model="managerClassificationSettings.feedbackReply.passive
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply.passiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inactive mt-32">
            <div class="fs-18 fw-700 fc-000000">
              {{ $t("insights.INACTIVE") }}
            </div>
            <div class="flex">
              <div>
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Insights_Open_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.inactive
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.inactiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
              <div class="ml-40">
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Feedback_Reply_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply.inactive
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply
        .inactiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-reverse" style="margin-top: 72px">
            <el-button @click="setManagerClassificationSettings" style="
                background-color: #32c2d5;
                color: #fff;
                border-radius: 3px;
                width: 100px;
                height: 50px;
              ">{{ $t("insights.SAVE") }}</el-button>
            <el-button style="
                background-color: #d1d1d1;
                color: #fff;
                border-radius: 3px;
                margin-right: 12px;
                width: 120px;
                height: 50px;
              " @click="beforeCloseSettingsModal">{{ $t("insights.CANCEL") }}</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- Proactivity Rating Breakdown Modal -->
      <el-dialog
        :visible.sync="showProactivityModal"
        title="Proactivity Rating Breakdown"
        width="900px"
        :close-on-click-modal="true"
        :show-close="true"
        custom-class="breakdown-modal"
      >
        <div class="modal-breakdown">
          <div class="modal-header">
            <div class="header-content">
              <div class="score-display">
                <div class="score-number">{{ adjustedProactivityRatingValue }}</div>
                <div class="score-denominator">/100</div>
              </div>
              <div class="score-context">
                <div class="score-label">Overall Proactivity Rating</div>
              </div>
              <div class="score-status-container">
                <div class="score-status" :class="adjustedProactivityRatingValue >= 70 ? 'excellent' : adjustedProactivityRatingValue >= 50 ? 'good' : adjustedProactivityRatingValue >= 30 ? 'needs-improvement' : 'poor'">
                  {{ adjustedProactivityRatingValue >= 70 ? 'Excellent Performance' : adjustedProactivityRatingValue >= 50 ? 'Good Performance' : adjustedProactivityRatingValue >= 30 ? 'Needs Improvement' : 'Requires Attention' }}
                </div>
              </div>
            </div>
          </div>
          
          <div class="modal-content-grid">
            <div class="components-column">
              <div class="breakdown-section">
                <div class="section-header">
                  <h3 class="breakdown-title">Performance Components</h3>
                  <div class="calculation-note">
                    <i class="el-icon-info"></i>
                    <span v-if="isPerformanceBoostEnabled">Components are weighted: <strong>35%</strong> Feedback Reply Rate, <strong>30%</strong> Conversation Initiated, <strong>20%</strong> Peer Feedback, <strong>15%</strong> Performance Feedback</span>
                    <span v-else>Components are weighted: <strong>41%</strong> Feedback Reply Rate, <strong>35%</strong> Conversation Initiated, <strong>24%</strong> Peer Feedback</span>
                  </div>
                </div>
                
                <div class="component-item">
                  <div class="component-header">
                    <span class="component-name">Feedback Reply Rate</span>
                    <span class="performance-indicator-header" :class="(insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0) >= 70 ? 'good' : (insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0) >= 40 ? 'needs-attention' : 'poor'">
                      {{ (insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0) >= 70 ? 'Good' : (insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0) >= 40 ? 'Needs Attention' : 'Poor' }}
                    </span>
                  </div>
                  <div class="component-bar">
                    <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0))}%; background-color: ${(insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0) >= 70 ? '#66bb6a' : (insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0) >= 40 ? '#fbc02d' : '#f44336'}`"></div></div>
                    <span class="component-value">{{ insight.proactivityComponents && insight.proactivityComponents.feedbackReplyRate ? insight.proactivityComponents.feedbackReplyRate : 0 }}/100</span>
                  </div>
                  <div class="component-description">Manager's responsiveness to team feedback</div>
                </div>

                <div class="component-item">
                  <div class="component-header">
                    <span class="component-name">Conversation Initiated</span>
                    <span class="performance-indicator-header" :class="(insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0) >= 70 ? 'good' : (insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0) >= 40 ? 'needs-attention' : 'poor'">
                      {{ (insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0) >= 70 ? 'Good' : (insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0) >= 40 ? 'Needs Attention' : 'Poor' }}
                    </span>
                  </div>
                  <div class="component-bar">
                    <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0))}%; background-color: ${(insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0) >= 70 ? '#66bb6a' : (insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0) >= 40 ? '#fbc02d' : '#f44336'}`"></div></div>
                    <span class="component-value">{{ insight.proactivityComponents && insight.proactivityComponents.conversationInitiated ? Math.round(insight.proactivityComponents.conversationInitiated) : 0 }}/100</span>
                  </div>
                  <div class="component-description">Proactive upward communication with their own manager</div>
                </div>

                <div class="component-item">
                  <div class="component-header">
                    <span class="component-name">Peer Feedback</span>
                    <span class="performance-indicator-header" :class="(insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0) >= 70 ? 'good' : (insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0) >= 40 ? 'needs-attention' : 'poor'">
                      {{ (insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0) >= 70 ? 'Good' : (insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0) >= 40 ? 'Needs Attention' : 'Poor' }}
                    </span>
                  </div>
                  <div class="component-bar">
                    <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0))}%; background-color: ${(insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0) >= 70 ? '#66bb6a' : (insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0) >= 40 ? '#fbc02d' : '#f44336'}`"></div></div>
                    <span class="component-value">{{ insight.proactivityComponents && insight.proactivityComponents.peerFeedback ? Math.round(insight.proactivityComponents.peerFeedback) : 0 }}/100</span>
                  </div>
                  <div class="component-description">Percentage of managers requesting peer feedback</div>
                </div>

                <div v-if="isPerformanceBoostEnabled" class="component-item">
                  <div class="component-header">
                    <span class="component-name">Performance Feedback</span>
                    <span class="performance-indicator-header" :class="(insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0) >= 70 ? 'good' : (insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0) >= 40 ? 'needs-attention' : 'poor'">
                      {{ (insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0) >= 70 ? 'Good' : (insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0) >= 40 ? 'Needs Attention' : 'Poor' }}
                    </span>
                  </div>
                  <div class="component-bar">
                    <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0))}%; background-color: ${(insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0) >= 70 ? '#66bb6a' : (insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0) >= 40 ? '#fbc02d' : '#f44336'}`"></div></div>
                    <span class="component-value">{{ insight.proactivityComponents && insight.proactivityComponents.topPerformerRecognition ? insight.proactivityComponents.topPerformerRecognition : 0 }}/100</span>
                  </div>
                  <div class="component-description">Percentage of performance reviews completed or pending</div>
                </div>
              </div>
            </div>
            
            <div class="chart-column">
              <div class="trend-section">
                <div class="trend-title">3-Month Trend</div>
                <div class="trend-chart-container">
                  <canvas ref="proactivityTrendChartModal" class="trend-chart"></canvas>
                </div>
                <div class="trend-legend">
                  <span class="trend-period">{{ getTrendPeriodLabel() }}</span>
                  <span class="trend-note">Calendar month avg</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- Psychological Safety Breakdown Modal -->
      <el-dialog
        :visible.sync="showPsychologicalModal"
        title="Psychological Safety Breakdown"
        width="900px"
        :close-on-click-modal="true"
        :show-close="true"
        custom-class="breakdown-modal"
      >
        <div class="modal-breakdown">
          <div class="modal-header">
            <div class="header-content">
              <div class="score-display">
                <div class="score-number">{{ _activeOverview.psychologicalRatingValue }}</div>
                <div class="score-denominator">/100</div>
              </div>
              <div class="score-context">
                <div class="score-label">Psychological Safety Rating</div>
              </div>
              <div class="score-status-container">
                <div class="score-status" :class="_activeOverview.psychologicalRatingValue >= 70 ? 'excellent' : _activeOverview.psychologicalRatingValue >= 50 ? 'good' : _activeOverview.psychologicalRatingValue >= 30 ? 'needs-improvement' : 'poor'">
                  {{ _activeOverview.psychologicalRatingValue >= 70 ? 'Excellent Environment' : _activeOverview.psychologicalRatingValue >= 50 ? 'Good Environment' : _activeOverview.psychologicalRatingValue >= 30 ? 'Needs Improvement' : 'Requires Attention' }}
                </div>
              </div>
            </div>
          </div>
          
          <div class="modal-content-grid">
            <div class="components-column">
              <div class="breakdown-section">
                <div class="section-header">
                  <h3 class="breakdown-title">Safety Components</h3>
                  <div class="calculation-note">
                    <i class="el-icon-info"></i>
                    <span>Each component is scored 0-100, then <strong>weighted</strong> to create the final psychological safety score</span>
                  </div>
                </div>
                
                <div class="component-item">
                  <div class="component-header">
                    <span class="component-name">Feedback Participation</span>
                    <span class="performance-indicator-header" :class="(_activeOverview.participationIndex || 0) >= 70 ? 'good' : (_activeOverview.participationIndex || 0) >= 50 ? 'needs-attention' : 'poor'">
                      {{ (_activeOverview.participationIndex || 0) >= 70 ? 'Good' : (_activeOverview.participationIndex || 0) >= 50 ? 'Needs Attention' : 'Poor' }}
                    </span>
                  </div>
                  <div class="component-bar">
                    <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (_activeOverview.participationIndex || 0))}%; background-color: ${(_activeOverview.participationIndex || 0) >= 70 ? '#66bb6a' : (_activeOverview.participationIndex || 0) >= 50 ? '#fbc02d' : '#f44336'}`"></div></div>
                    <span class="component-value">{{ _activeOverview.participationIndex || 0 }}/100</span>
                  </div>
                  <div class="component-description">Team engagement in feedback processes</div>
                </div>

                <el-tooltip placement="right" effect="light" popper-class="voice-safety-tooltip">
                  <div slot="content">
                    <div class="vs-tooltip-title">Feedback Breakdown</div>
                    <div class="vs-tooltip-row">
                      <span class="vs-tooltip-label">Anonymous</span>
                      <span class="vs-tooltip-value">{{ _activeOverview.anonymousPercent || 0 }}%</span>
                    </div>
                    <div class="vs-tooltip-bar">
                      <div class="vs-tooltip-bar-fill vs-tooltip-bar-anon" :style="`width: ${_activeOverview.anonymousPercent || 0}%`"></div>
                      <div class="vs-tooltip-bar-fill vs-tooltip-bar-open" :style="`width: ${100 - (_activeOverview.anonymousPercent || 0)}%`"></div>
                    </div>
                    <div class="vs-tooltip-row">
                      <span class="vs-tooltip-label">Open</span>
                      <span class="vs-tooltip-value">{{ 100 - (_activeOverview.anonymousPercent || 0) }}%</span>
                    </div>
                  </div>
                  <div class="component-item component-item--hoverable">
                    <div class="component-header">
                      <span class="component-name">Voice Safety</span>
                      <span class="performance-indicator-header" :class="(_activeOverview.voiceSafetyIndex || 0) >= 70 ? 'good' : (_activeOverview.voiceSafetyIndex || 0) >= 50 ? 'needs-attention' : 'poor'">
                        {{ (_activeOverview.voiceSafetyIndex || 0) >= 70 ? 'Good' : (_activeOverview.voiceSafetyIndex || 0) >= 50 ? 'Needs Attention' : 'Poor' }}
                      </span>
                    </div>
                    <div class="component-bar">
                      <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (_activeOverview.voiceSafetyIndex || 0))}%; background-color: ${(_activeOverview.voiceSafetyIndex || 0) >= 70 ? '#66bb6a' : (_activeOverview.voiceSafetyIndex || 0) >= 50 ? '#fbc02d' : '#f44336'}`"></div></div>
                      <span class="component-value">{{ _activeOverview.voiceSafetyIndex || 0 }}/100</span>
                    </div>
                    <div class="component-description">How openly team members share feedback</div>
                  </div>
                </el-tooltip>

                <div class="component-item">
                  <div class="component-header">
                    <span class="component-name">Super Feedback Rate</span>
                    <span class="performance-indicator-header" :class="(_activeOverview.superFeedbackRate || 0) >= 70 ? 'good' : (_activeOverview.superFeedbackRate || 0) >= 50 ? 'needs-attention' : 'poor'">
                      {{ (_activeOverview.superFeedbackRate || 0) >= 70 ? 'Good' : (_activeOverview.superFeedbackRate || 0) >= 50 ? 'Needs Attention' : 'Poor' }}
                    </span>
                  </div>
                  <div class="component-bar">
                    <div class="bar-track"><div class="bar-fill" :style="`width: ${Math.min(100, (_activeOverview.superFeedbackRate || 0))}%; background-color: ${(_activeOverview.superFeedbackRate || 0) >= 70 ? '#66bb6a' : (_activeOverview.superFeedbackRate || 0) >= 50 ? '#fbc02d' : '#f44336'}`"></div></div>
                    <span class="component-value">{{ _activeOverview.superFeedbackRate || 0 }}/100</span>
                  </div>
                  <div class="component-description">Quality and depth of feedback received</div>
                </div>
              </div>
            </div>
            
            <div class="chart-column">
              <div class="trend-section">
                <div class="trend-title">3-Month Trend</div>
                <div class="trend-chart-container">
                  <canvas ref="psychologicalTrendChartModal" class="trend-chart"></canvas>
                </div>
                <div class="trend-legend">
                  <span class="trend-period">{{ getTrendPeriodLabel() }}</span>
                  <span class="trend-note">Calendar month avg</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import imageTooltip from "../../assets/images/insights/ic_direct_reports@2x.png";
import store from "@/store/store";

export default {
  name: "managers",
  components: {
    modalPreviewUser: require("@/components/even/modal/user-preview").default,
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    const initialTeamSelection =
      this.user.user_type == "leadership" ? this.user.team : "all";
    const initialLoadTeam =
      this.user.user_type == "leadership" ? this.user.team : undefined;

    this.$store.commit("insightsManagers/setTeamSelected", initialTeamSelection);
    this.$store.dispatch("team/getTeamsOptionsFixed", this.user);

    this.$store
      .dispatch("insightsManagers/getDataAll", initialLoadTeam)
      .then(() => {
        this.$store.dispatch("insightsManagers/loadWeeklyResponsivenessData");
        this.$store.dispatch("insightsManagers/getManagerTodoList");
      });

    // this.$store.dispatch("insightsManagers/getDataOverview");
    // this.$store.dispatch("insightsManagers/getNudges");
    //this.$store.dispatch("insightsManagers/getDataOverview");


    // this.$store.dispatch("insightsManagers/setLastCoaching", this.user);
    // this.$store.dispatch("insightsManagers/getDataAll");
    // this.$store.dispatch("insightsManagers/getdatalistAll");
    // this.$store.dispatch("insightsManagers/getManagerClassificationSettings");
  },
  watch: {
    optionsTeam() {
      if (this.optionsTeam.length > 0 && !this.selectTeam) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    insightsOpenPassiveSetting() {
      this.setValueManagerClassificationSettings();
    },
    datalistSearchAll() {
      if (this.myChart) this.myChart.destroy()
      this.createChart();
    },

    // Redundant
    /*
    loadingManager(value) {
      console.log(`watch: loadingManager(${value ? "true" : "false"})`);
      if (value) return;
      setTimeout(() => {
        console.log("watch: loadingManager, setTimeout(300)");
        this.createChart();
        this.createChartQuality();
      }, 300);
    },
    //*/

    selectTeam() {
      this.$store.dispatch("insightsManagers/setTeamSorting", this.selectTeam);
      // Clear cached historical data when team changes so fresh data is fetched
      this.historicalProactivityRatings = null;
      this.proactivityTrendData = {};
    },
    inputSearch() {
      this.$store.dispatch(
        "insightsManagers/setSearchingText",
        this.inputSearch
      );
    },
    weeklyData() {
      if (this.myChart1) this.myChart1.destroy()
      this.createChartQuality();
    },
    selectedClass() {
      // Reset pagination to first page when changing manager class filter
      this.$store.dispatch("insightsManagers/currentManagerChange", 1);
      
      // If no results are found and we expect some, log debug info
      if (this.filteredManagers.length === 0 && this.selectedClass !== 'all') {
        console.log(`No results found for ${this.selectedClass} filter`);
        // Log a sample of managers to debug
        if (this.datalist.length > 0) {
          const sampleManager = this.datalist[0];
          console.log('Sample manager data:', {
            name: sampleManager.fullname,
            email: sampleManager.email,
            replyRate: sampleManager.feedback,
            openRate: sampleManager.overall_rate,
            performance: this.dataQualitybyTeam[sampleManager.email] || 'No performance data'
          });
        }
      }
    },
    // Watch for manager trend data changes to render chart
    managerTrendData: {
      handler(newData) {
        if (newData && newData.datasets && newData.datasets.length > 0 && !this.loadingManager) {
          this.scheduleResponsivenessTrendChartRender();
        }
      },
      deep: true,
      immediate: true,
    },
    // Also watch loadingManager to render chart when loading completes
    loadingManager(newVal) {
      if (!newVal && this.managerTrendData && this.managerTrendData.datasets && this.managerTrendData.datasets.length > 0) {
        this.scheduleResponsivenessTrendChartRender();
      }
    },

  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    isPerformanceBoostEnabled() {
      return this.$store.getters["insightsManagers/performanceBoostEnabled"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsfixedall"];
    },
    optionsTeam_Temp() {
      return this.$store.getters["team/teamsfixedall_temp"];
    },
    managerResults() {
      return this.$store.getters["insightsManagers/managerResults"];
    },
    datalist() {
      return this.$store.getters["insightsManagers/datalist"];
    },
    datalistSearchAll() {
      return this.$store.getters["insightsManagers/datalistSearchAll"];
    },
    teamList() {
      return this.$store.getters["insightsManagers/teamList"];
    },
    activeOverview() {
      return this.$store.getters["insightsManagers/activeOverview"];
    },
    loadingManager() {
      return this.$store.getters["insightsManagers/loadingManager"];
    },
    loadingCoaching() {
      return this.$store.getters["insightsManagers/loadingCoaching"];
    },
    insightsOpenPassiveSetting() {
      return this.$store.getters["insightsManagers/getInsightsOpenRateSetting"];
    },
    feedbackReplyPassiveSetting() {
      return this.$store.getters[
        "insightsManagers/getFeedbackReplyRateSetting"
      ];
    },
    showSnackbar() {
      return this.$store.getters["insightsManagers/showSnackbar"];
    },
    modalCoachingData() {
      return this.$store.getters["insightsManagers/modalCoachingData"];
    },

    feedback() {
      return this.$store.getters["dashboard/feedback"];
    },
    loadingManagerOverview() {
      return this.$store.getters["insightsManagers/loadingManagerOverview"];
    },
    _activeOverview() {
      return this.$store.getters["insightsManagers/_activeOverview"];
    },
    loadingManagerNudges() {
      return this.$store.getters["insightsManagers/loadingManagerNudges"];
    },
    nudges() {
      return this.$store.getters["insightsManagers/nudges"];
    },
    insight() {
      return this.$store.getters["insightsManagers/insight"];
    },
    loadingManagerInsight() {
      return this.$store.getters["insightsManagers/loadingManagerInsight"];
    },
    loadingresponse() {
      return this.$store.getters["insightsManagers/loadingresponse"];
    },
    membersall() {
      return this.$store.getters["insightsManagers/membersall"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.userDetail.firstname || "",
        lastname: this.userDetail.lastname || "",
        teamColor: this.userDetail.house_color || "",
        house: this.userDetail.house || "",
        pic: this.userDetail.large_pic || false,
      };
      return passProfile;
    },
    modalMemberData() {
      return this.$store.getters["people/modalMemberData"];
    },
    response() {
      return this.$store.getters["insightsManagers/response"];
    },
    dataQualitybyTeam() {

      return this.$store.getters["insightsManagers/dataQualitybyTeam"];
    },
    insightresponse() {
      return this.$store.getters["insightsManagers/insightresponse"];
    },
    label() {
      return this.$store.getters["insightsManagers/label"];
    },
    weeklyData() {
      return this.$store.getters["insightsManagers/weeklyData"];
    },
    standards_data() {
      return this.$store.getters["insightsManagers/standards_data"];
    },
    formattedCriticalAreas() {
      return (criticalArea) => {
        return criticalArea.split(',').map(item => item.trim());
      };
    },
    // Manager To-do List computed properties
    managerTodoList() {
      return this.$store.getters["insightsManagers/managerTodoList"];
    },
    managerTodoSelectedWeek() {
      return this.$store.getters["insightsManagers/managerTodoSelectedWeek"];
    },
    managerTodoAvailableWeeks() {
      return this.$store.getters["insightsManagers/managerTodoAvailableWeeks"];
    },
    loadingManagerTodos() {
      return this.$store.getters["insightsManagers/loadingManagerTodos"];
    },
    noFilterResults() {
      return this.selectedClass !== 'all' && this.filteredManagers.length === 0;
    },
    memberbyteam(){
      return this.$store.getters["insightsManagers/memberbyteam"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    user_placeholder(){
      return this.$store.getters["insightsManagers/user_placeholder"];
    },
    teamHeight(){
      return this.$store.getters["insightsManagers/teamHeight"];
    },
    adjustedProactivityRatingValue() {
      // Simply return the proactivity rating value as calculated in the store
      return this.insight ? this.insight.proactivityRatingValue : 0;
    },
    proactivityTooltipKey() {
      // Create a reactive key that changes when relevant data changes
      return `proactivity-${this.adjustedProactivityRatingValue}`;
    },
    filteredManagers() {
      // Always log filter selection for debugging
      console.log(`Selected filter: ${this.selectedClass}`);
      console.log(`Total managers available (paginated): ${this.datalist.length}`);
      console.log(`Total managers available (full dataset): ${this.datalistSearchAll.length}`);
      
      // Special case for elite filter - use a completely different approach
      if (this.selectedClass === 'elite') {
        // Use the FULL dataset (datalistSearchAll) instead of just the paginated view (datalist)
        const completeManagerList = Array.isArray(this.datalistSearchAll) ? 
                                  this.datalistSearchAll : 
                                  Object.values(this.datalistSearchAll);
        
        console.log(`Searching through ${completeManagerList.length} total managers for elite managers`);
        
        // Dump sample managers for debugging
        if (completeManagerList.length > 0) {
          console.log("Sample managers data:");
          completeManagerList.slice(0, 3).forEach(m => {
            console.log(`${m.fullname}:`, {
              email: m.email,
              feedback: m.feedback,
              boostsOnTrack: this.dataQualitybyTeam[m.email] && 
                            this.dataQualitybyTeam[m.email].performance_review && 
                            this.dataQualitybyTeam[m.email].performance_review.reviewCompleted || 'N/A',
              debi: this.dataQualitybyTeam[m.email] && 
                   this.dataQualitybyTeam[m.email].DEBI || 'N/A'
            });
          });
        }
        
        // Find elite managers in the FULL dataset
        const eliteManagers = completeManagerList.filter(manager => {
          if (!manager) return false;
          
          // Look specifically for Jafferi managers first
          if (manager.fullname && (
              manager.fullname.toLowerCase().includes('jafferi') || 
              (manager.email && manager.email.toLowerCase().includes('jafferi'))
          )) {
            console.log(`Found Jafferi manager: ${manager.fullname}`);
            return true;
          }
          
          // Try to parse values carefully, preserving decimals
          try {
            // Parse replyRate
            let replyRate = 0;
            if (typeof manager.feedback === 'string') {
              // Just use direct parseFloat without replacing characters
              replyRate = parseFloat(manager.feedback);
            } else if (typeof manager.feedback === 'number') {
              replyRate = manager.feedback;
            }
            
            // Parse boostsOnTrack (reviewCompleted)
            let boostsOnTrack = 0;
            if (this.dataQualitybyTeam && this.dataQualitybyTeam[manager.email] && 
                this.dataQualitybyTeam[manager.email].performance_review) {
              const reviewValue = this.dataQualitybyTeam[manager.email].performance_review.reviewCompleted;
              if (typeof reviewValue === 'string') {
                // Just use direct parseFloat without replacing characters
                boostsOnTrack = parseFloat(reviewValue);
              } else if (typeof reviewValue === 'number') {
                boostsOnTrack = reviewValue;
              }
            }
            
            // Parse DEBI score
            let debi = 0;
            if (this.dataQualitybyTeam && this.dataQualitybyTeam[manager.email]) {
              const debiValue = this.dataQualitybyTeam[manager.email].DEBI;
              if (typeof debiValue === 'string') {
                // Just use direct parseFloat without replacing characters
                debi = parseFloat(debiValue);
              } else if (typeof debiValue === 'number') {
                debi = debiValue;
              }
            }
            
            // Adjusted elite criteria
            const isHighReplyRate = replyRate >= 80;
            const isHighBoosts = boostsOnTrack >= 80;
            const isHighDebi = debi >= 60;

            // When performance boosts disabled, exclude boosts from criteria
            const eliteMatch = this.isPerformanceBoostEnabled
              ? (isHighReplyRate && isHighBoosts && isHighDebi)
              : (isHighReplyRate && isHighDebi);

            if (eliteMatch) {
              console.log(`Elite manager found: ${manager.fullname}`);
              return true;
            }

            return false;
          } catch (error) {
            console.error(`Error processing manager ${manager.fullname}:`, error);
            return false;
          }
        });
        
        console.log(`Found ${eliteManagers.length} elite managers`);
        return eliteManagers;
      }
      
      // For all other filters, also use the FULL dataset
      if (this.selectedClass === 'all') return this.datalist; // Keep original behavior for "all"
      
      // Use the FULL dataset for other filters too
      const completeManagerList = Array.isArray(this.datalistSearchAll) ? 
                                this.datalistSearchAll : 
                                Object.values(this.datalistSearchAll);
      
      // Add correct parseFloat for the other filters as well
      const parseValue = (value) => {
        if (typeof value === 'string') {
          // Just use parseFloat directly instead of stripping characters first
          return parseFloat(value) || 0;
        } else if (typeof value === 'number') {
          return value;
        }
        return 0;
      };
      
      const filtered = completeManagerList.filter(manager => {
        if (!manager) return false;
        
        // Extract manager data and parse numbers WITH DECIMAL POINT SUPPORT
        const email = manager.email;
        const replyRate = parseValue(manager.feedback);
        const openRate = parseValue(manager.overall_rate);
        
        // Get data quality metrics
        const dqData = this.dataQualitybyTeam && this.dataQualitybyTeam[email] ? 
                      this.dataQualitybyTeam[email] : {};
        
        // Get performance data
        const performance = dqData && dqData.performance_review ? 
                          dqData.performance_review : {};
        
        // Parse metrics with decimal support
        const conversations = parseValue(dqData.conversations_initiated);
        const debi = parseValue(dqData.DEBI);
        const boostsOnTrack = parseValue(performance.reviewCompleted);
        
        // Apply class filters (exclude boosts criteria when performance boosts disabled)
        const boostOn = this.isPerformanceBoostEnabled;
        switch (this.selectedClass) {
          case 'effective': // High Performers: Between Rising Stars and Elite Managers
            return replyRate >= 60 && (boostOn ? boostsOnTrack >= 60 : true) && debi >= 50;
          case 'rising':
            return replyRate >= 40 && (boostOn ? boostsOnTrack >= 40 : true) && debi >= 40;
          case 'fb_champ':
            return conversations >= 60 && replyRate >= 60;
          case 'risk':
            return replyRate < 30 || debi < 40;
          case 'ghost':
            return conversations === 0 && replyRate === 0 && (boostOn ? boostsOnTrack === 0 : true);
          case 'newmgr':
            return manager.to_now && parseInt(String(manager.to_now)) < 180; // Less than 6 months
          default:
            return true;
        }
      });
      
      console.log(`Found ${filtered.length} managers matching filter: ${this.selectedClass}`);
      return filtered;
    },
    hasPsychologicalSafetyImprovements() {
      if (!this._activeOverview) return true; // Show by default if no data
      
      // Check if any of the conditional improvements would be shown
      const hasConditionalImprovements = 
        (this._activeOverview.participationPatterns || 78) < 70 ||
        (this._activeOverview.voiceSafety || 85) < 70 ||
        (this._activeOverview.recognitionClimate || 82) < 70;
      
      // Always show if there are conditional improvements OR if we have the static ones
      return hasConditionalImprovements || true; // Static items always present
    },
    hasProactivityImprovements() {
      if (!this.insight || !this.insight.proactivityComponents) return false;
      
      // Check if any of the conditional improvements would be shown
      const feedbackReplyRate = this.insight.proactivityComponents.feedbackReplyRate || 0;
      const conversationInitiated = this.insight.proactivityComponents.conversationInitiated || 0;
      const peerFeedback = this.insight.proactivityComponents.peerFeedback || 0;
      const topPerformerRecognition = this.insight.proactivityComponents.topPerformerRecognition || 0;
      
      return feedbackReplyRate < 70 || 
             conversationInitiated < 70 ||
             peerFeedback < 40 ||
             topPerformerRecognition < 70;
    },
    hasPsychologicalSafetyDetailedImprovements() {
      if (!this._activeOverview) return true; // Show by default if no data
      
      // Check if any of the conditional improvements would be shown
      const hasConditionalImprovements = 
        (this._activeOverview.participationIndex || 0) < 70 ||
        (this._activeOverview.voiceSafetyIndex || 0) < 70 ||
        (this._activeOverview.superFeedbackRate || 0) < 70;
      
      // Always show if there are conditional improvements OR if we have the static one
      return hasConditionalImprovements || true; // Static item always present
    },
    peerFeedbackHistoryData(){
      return this.$store.getters["insightsManagers/peerFeedbackHistory"];
    },
    // Manager Responsiveness Trend computed property
    managerTrendData() {
      return this.$store.getters["insightsManagers/getManagerResponsivenessTrend"];
    },
    // Total Action Items Summary computed property
    actionItemsSummary() {
      return this.$store.getters["insightsManagers/totalActionItemsSummary"];
    },
  },
  data() {
    return {
      myChart: "",
      myChart1: "",
      selectTeam: "",
      selectStatus: "all",
      inputSearch: "",
      coachingModalStatus: false,
      settingsStatus: false,
      discardedSettingStatus: false,
      managerClassificationSettings: {
        insightsOpen: {
          max: 100,
          active: 60,
          passiveUpper: 59,
          passive: 20,
          inactiveUpper: 19,
          inactive: 0,
        },
        feedbackReply: {
          max: 100,
          active: 40,
          passiveUpper: 39,
          passive: 10,
          inactiveUpper: 9,
          inactive: 0,
        },
      },
      loadingOverview: true,
      //proactivityRatingValue: 34,
      benchmarkProactivityRatingScore: 60,
      psychologicalRatingValue: 82,
      benchmarkPsychologicalRatingScore: 80,
      replyRate: 32,
      replyRateChange: 32,
      replyQuality: 54,
      replyQualityChange: 21,
      // performerRecognition: 52,
      // performerRecognitionChange: 18,
      dailyInsightsPercentage: 87,
      dailyInsightsChange: 7,
      weeklyInsightsPercentage: 65,
      weeklyInsightsChange: 7,
      userDetail: {},
      modalPreviewDataStatus: false,
      selectChart: "vs Open Rate",
      selectedClass: "all",
      trendCharts: {}, // Store references to trend charts
      proactivityTrendData: {}, // Store trend data for each manager
      historicalProactivityRatings: null, // Store real historical proactivity ratings from Firebase
      psychologicalTrendData: {}, // Store trend data for psychological safety
      proactivityTooltipTimer: null,
      psychologicalTooltipTimer: null,
      showProactivityModal: false,
      showPsychologicalModal: false,
      loadingPeerFeedbackHistory: false,
      //peerFeedbackHistoryData: {},
      peerFeedbackHistoryDisplay: [],
      currentPeerFeedbackManager: null,
      // Manager Responsiveness Trend chart instances
      responsivenessTrendChartInstance: null,
      responsivenessSingleWeekChartInstance: null,
      responsivenessTrendRenderFrame: null,

    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
    }

    // TODO: BACKEND INTEGRATION - Remove this line when API is ready
    // Initialize dummy peer feedback data for testing
   // this.initializeDummyPeerFeedbackData();

    // this.setValueManagerClassificationSettings();
    //this.createChart();
    setTimeout(() => {
      this.loadingOverview = false;
    }, 2000);

    // Try rendering responsiveness trend chart if data is already available
    this.$nextTick(() => {
      if (this.managerTrendData && this.managerTrendData.datasets && this.managerTrendData.datasets.length > 0) {
        this.scheduleResponsivenessTrendChartRender();
      }
    });
  },
  beforeDestroy() {
    // Clean up all charts
    Object.keys(this.trendCharts).forEach(key => {
      if (this.trendCharts[key]) {
        try {
          this.trendCharts[key].destroy();
        } catch (e) {
          console.warn('Error destroying chart on unmount:', e);
        }
      }
    });
    
    // Clear timers
    if (this.proactivityTooltipTimer) {
      clearTimeout(this.proactivityTooltipTimer);
    }
    if (this.psychologicalTooltipTimer) {
      clearTimeout(this.psychologicalTooltipTimer);
    }
    if (this.responsivenessTrendRenderFrame) {
      window.cancelAnimationFrame(this.responsivenessTrendRenderFrame);
      this.responsivenessTrendRenderFrame = null;
    }
    
    // Clear cached trend data
    this.proactivityTrendData = {};
    this.psychologicalTrendData = {};
    this.historicalProactivityRatings = null;
    
    // Clean up responsiveness trend charts
    if (this.responsivenessTrendChartInstance) {
      try {
        this.responsivenessTrendChartInstance.destroy();
      } catch (e) {
        console.warn('Error destroying responsiveness trend chart:', e);
      }
    }
    if (this.responsivenessSingleWeekChartInstance) {
      try {
        this.responsivenessSingleWeekChartInstance.destroy();
      } catch (e) {
        console.warn('Error destroying responsiveness single week chart:', e);
      }
    }
  },
  methods: {
    // initializeDummyPeerFeedbackData() {
    //   // TODO: BACKEND INTEGRATION - REMOVE THIS FUNCTION
    //   // ==================================================
    //   // This function generates dummy/fake data for testing the peer feedback tooltip.
    //   // Once the backend API is ready, this entire function should be REMOVED.
    //   // Data will be fetched on-demand via the showPeerFeedbackHistory() method instead.
    //   // ==================================================

    //   // Generate dummy data for different managers with various patterns
    //   const dummyManagers = [
    //     { email: 'manager1@example.com', pattern: [2, 2, 1, 2, 1, 0] },
    //     { email: 'manager2@example.com', pattern: [1, 1, 2, 1, 0, 1] },
    //     { email: 'manager3@example.com', pattern: [0, 0, 1, 2, 2, 2] },
    //     { email: 'manager4@example.com', pattern: [2, 1, 1, 0, 1, 2] },
    //     { email: 'manager5@example.com', pattern: [0, 0, 0, 1, 1, 2] },
    //   ];

    //   const now = new Date();
    //   dummyManagers.forEach(manager => {
    //     this.peerFeedbackHistoryData[manager.email] = {};
    //     for (let i = 5; i >= 0; i--) {
    //       const monthKey = this.$dateFns.format(this.$dateFns.addMonths(now, -i), 'YYYY-MM');
    //       this.peerFeedbackHistoryData[manager.email][monthKey] = manager.pattern[5 - i];
    //     }
    //   });
    // },

    scheduleResponsivenessTrendChartRender() {
      this.$nextTick(() => {
        if (this.responsivenessTrendRenderFrame) {
          window.cancelAnimationFrame(this.responsivenessTrendRenderFrame);
        }
        this.responsivenessTrendRenderFrame = window.requestAnimationFrame(() => {
          this.renderResponsivenessTrendChart();
          this.responsivenessTrendRenderFrame = null;
        });
      });
    },

    async showPeerFeedbackHistory(managerEmail) {
      // Only load if we're hovering a new manager
      if (this.currentPeerFeedbackManager === managerEmail) {
        return;
      }

      this.currentPeerFeedbackManager = managerEmail;
      this.loadingPeerFeedbackHistory = true;
      try {
        if (!this.peerFeedbackHistoryData || Object.keys(this.peerFeedbackHistoryData).length === 0) {
          await this.$store.dispatch("insightsManagers/getPeerFeedbackHistory", this.user);
        }

        // Generate display data for last 6 months
        const displayData = [];
        const now = new Date();

        for (let i = 5; i >= 0; i--) {
          const monthDate = this.$dateFns.addMonths(now, -i);
          const monthKey = this.$dateFns.format(monthDate, 'YYYY-MM');
          const monthLabel = this.$dateFns.format(monthDate, 'MMM');

          displayData.push({
            label: monthLabel,
            count: this.peerFeedbackHistoryData[managerEmail]&&this.peerFeedbackHistoryData[managerEmail][monthKey]?this.peerFeedbackHistoryData[managerEmail][monthKey]:0,
            monthKey: monthKey
          });
        }

        this.peerFeedbackHistoryDisplay = displayData;
      } catch (error) {
        console.error("Error loading peer feedback history:", error);
        this.peerFeedbackHistoryDisplay = [];
      } finally {
        this.loadingPeerFeedbackHistory = false;
      }
    },

    changeChart(val) {
      this.selectChart = val
      this.$store.dispatch("insightsManagers/getChangeChartType", this.selectChart);
    },
    async handleTeams(key) {
      let team = key !== "all" ? this.optionsTeam_Temp[key].key_temp : "";
      this.selectTeam = key;
      // Set team in store FIRST before loading data
      this.$store.commit("insightsManagers/setTeamSelected", key);
      // Wait for getDataAll to complete (builds teamOneLevel)
      await this.$store.dispatch("insightsManagers/getDataAll", team);
      // Clear cache and reload weekly responsiveness data for the new team
      this.$store.commit("insightsManagers/setWeeklyResponsivenessData", []);
      this.$store.dispatch("insightsManagers/loadWeeklyResponsivenessData");
      //this.$store.dispatch("insightsManagers/getDataOverview", team);
      //this.$store.dispatch("insightsManagers/changeTeam", team);
    },
    handleCurrentManagerChange(val) {

      this.$store.dispatch("insightsManagers/currentManagerChange", val);
    },
    typeingSearchManager() {
      this.$store.dispatch("insightsManagers/searchManager", {
        value: this.inputSearch,
        typingTimeout: this.variable.typingTimeout,
      });
    },
    ManagerSort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("insightsManagers/sortManager", [
          column.property,
          order,
        ]);
      }
    },
    setValueManagerClassificationSettings() {
      let iopsa = this.insightsOpenPassiveSetting.active;
      let iopsp = this.insightsOpenPassiveSetting.passive;
      this.managerClassificationSettings.insightsOpen = {
        max: 100,
        active: iopsa,
        passive: iopsp,
        passiveUpper: iopsa - 1 < 0 ? 0 : iopsa - 1,
        inactiveUpper: iopsp - 1 < 0 ? 0 : iopsp - 1,
        inactive: 0,
      };
      let frpsa = this.feedbackReplyPassiveSetting.active;
      let frpsp = this.feedbackReplyPassiveSetting.passive;
      this.managerClassificationSettings.feedbackReply = {
        max: 100,
        active: frpsa,
        passive: frpsp,
        passiveUpper: frpsa - 1 < 0 ? 0 : frpsa - 1,
        inactiveUpper: frpsp - 1 < 0 ? 0 : frpsp - 1,
        inactive: 0,
      };
    },
    beforeCloseSettingsModal() {
      if (this.discardedSettingStatus) {
        this.setValueManagerClassificationSettings();
        this.$message({
          showClose: true,
          message: "Changes discarded.",
          type: "warning",
        });
      }
      this.settingsStatus = !this.settingsStatus;
    },
    returnStatus(status) {
      if (status == "completed") {
        return "Completed";
      } else if (status == "active") {
        return "Active";
      } else {
        return "Pending";
      }
    },
    checkedLowerAndUpperSetting() {
      let insightStatus = true,
        feedbackReplyStatus = true;

      let insightActiveLower =
        this.managerClassificationSettings.insightsOpen.active;
      let insightPassiveUpper =
        this.managerClassificationSettings.insightsOpen.passive;
      if (parseInt(insightActiveLower) < parseInt(insightPassiveUpper)) {
        setTimeout(() => {
          this.$message({
            showClose: true,
            message: `[ Insights Open Rate ] ACTIVE Rate can not be lower then PASSIVE Rate!`,
            type: "error",
          });
        }, 100);
        insightStatus = false;
      }

      let feedbackActiveLower =
        this.managerClassificationSettings.feedbackReply.active;
      let feedbackPassiveUpper =
        this.managerClassificationSettings.feedbackReply.passive;
      if (parseInt(feedbackActiveLower) < parseInt(feedbackPassiveUpper)) {
        setTimeout(() => {
          this.$message({
            showClose: true,
            message: `[Insights Open Rate] ACTIVE Rate can not be lower then PASSIVE Rate!`,
            type: "error",
          });
        }, 400);
        feedbackReplyStatus = false;
      }
      return insightStatus && feedbackReplyStatus;
    },
    changeActiveInsightsOpen(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.insightsOpen.active = value;
      this.managerClassificationSettings.insightsOpen.passiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    changeActiveFeedbackReply(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.feedbackReply.active = value;
      this.managerClassificationSettings.feedbackReply.passiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    changePassiveInsightsOpen(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.insightsOpen.passive = value;
      this.managerClassificationSettings.insightsOpen.inactiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    changePassiveFeedbackRepl(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.feedbackReply.passive = value;
      this.managerClassificationSettings.feedbackReply.inactiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    returnNumberForInput(value) {
      this.discardedSettingStatus = true;
      let reg = /\D/g;
      let input = value.replace(reg, "");
      let text = input,
        textLength = input.length;
      if (textLength > 2) {
        text = text.substring(textLength - 2, textLength);
        let status = parseInt(text) > 9;

        if (!status) {
          text = text.substring(textLength - 2, textLength);
        }
        return text;
      } else {
        return text;
      }
    },
    setManagerClassificationSettings() {
      if (this.checkedLowerAndUpperSetting()) {
        this.$store.dispatch(
          "insightsManagers/setManagerClassificationSettings",
          {
            insightActiveLower:
              this.managerClassificationSettings.insightsOpen.active,
            insightPassiveUpper:
              this.managerClassificationSettings.insightsOpen.passive,
            feedbackActiveLower:
              this.managerClassificationSettings.feedbackReply.active,
            feedbackPassiveUpper:
              this.managerClassificationSettings.feedbackReply.passive,
          }
        );
        this.setValueManagerClassificationSettings();
        this.discardedSettingStatus = false;
        this.settingsStatus = !this.settingsStatus;
        setTimeout(() => {
          this.createChart();
        }, 300);
      }
    },
    addSpace(arr) {
      let text = arr.split(",");
      return text.join(", ");
    },
    countArr(arr) {
      let text = arr.split(",");
      return text.length;
    },
    sortBy(type) {
      this.selectStatus = type;
      this.$store.dispatch("insightsManagers/setStatusSorting", type);
    },
    async exportTable() {
      this.$store.dispatch("insightsManagers/getDataExport");
    },
    modalCoachingClick(email) {
      this.$store.dispatch("insightsManagers/resetState");
      this.$store.dispatch("insightsManagers/getDataCoaching", email);
      this.coachingModalStatus = !this.coachingModalStatus;
      this.modalPreviewDataStatus = false;
    },
    getPointRadius() {
      let radiusArr = [];
      for (const manager in this.datalistSearchAll) {
        let minnimaxRadius = 4,
          maxRadius = 14;
        let directReport = this.datalistSearchAll[manager].directReport;
        let redius = Math.trunc(directReport / 5 + (minnimaxRadius - 1));
        if (redius < minnimaxRadius) {
          radiusArr.push(minnimaxRadius);
        } else if (redius > maxRadius) {
          radiusArr.push(maxRadius);
        } else {
          radiusArr.push(redius);
        }
      }
      return radiusArr;
    },
    getPointColor() {
      let colorArr = [];
      for (const manager in this.datalistSearchAll) {
        if (this.datalistSearchAll[manager].activity_type == "Active") {
          colorArr.push("#66bb6a");
        } else if (this.datalistSearchAll[manager].activity_type == "Passive") {
          colorArr.push("#fbc02d");
        } else {
          colorArr.push("#f44336");
        }
      }
      return colorArr;
    },
    createChart() {

      var managerChart = this.$refs.managerChart;
      // console.log(managerChart ? "managerChart(yes)" : "managerChart(no)");
      if (!managerChart) {
        // console.log("managerCanvas was not found.");
        setTimeout(() => {
          // console.log("managerCanvas is called again");
          this.createChart();
        }, 1000);
        return;
      }

      let data = [...this.datalistSearchAll];
      let pointRadius = [...this.getPointRadius()];
      let pointColor = [...this.getPointColor()];
      if (managerChart) {
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.layout = {
          padding: {
            top: 10,
          },
          autoPadding: false,
        };
        options.scales = {
          y: {
            beginAtZero: true,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
            weight: 10,
          },
          x: {
            beginAtZero: true,
            ticks: {
              display: true,
              stepSize: 10,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
        };
        options.interaction = {
          mode: "nearest",
          intersect: false,
        };
        const getOrCreateTooltip = (chart) => {
          let tooltipEl = chart.canvas.parentNode.querySelector("div");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.style.background = "rgba(0, 0, 0, 0.7)";
            tooltipEl.style.borderRadius = "3px";
            tooltipEl.style.color = "white";
            tooltipEl.style.opacity = 1;
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.transform = "translate(-50%, 0)";
            tooltipEl.style.transition = "all .1s ease";

            const table = document.createElement("table");
            table.style.margin = "0px";

            tooltipEl.appendChild(table);
            chart.canvas.parentNode.appendChild(tooltipEl);
          }

          return tooltipEl;
        };

        const externalTooltipHandler = (context) => {
          // Tooltip Element
          const { chart, tooltip } = context;
          const tooltipEl = getOrCreateTooltip(chart);

          // Hide if no tooltip
          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set Text
          if (tooltip.body) {
            // const titleLines = tooltip.title || [];
            const bodyLines = tooltip.body.map((b) => b.lines);

            const tableHead = document.createElement("thead");

            const tableBody = document.createElement("tbody");

            let toolClass = 'container-tooltip';
            if ( this.blurMode ) {
              toolClass = 'blurelement';
            }

            bodyLines.forEach((body, i) => {
              const index = tooltip.dataPoints[i].dataIndex;
              const node = tooltip.dataPoints[i].dataset.data[index];
              let imagProfile = `<div style="height: 32px; width: 32px; margin: 0px 3px; display: flex; justify-content: center; align-items: center; background-color: #5f5f5f; border-radius: 32px;">
                ${node.shortname}
              </div>`;
              if (node.profilepic) {
                imagProfile = `<div style="height: 32px; width: 32px; margin: 0px 3px; display: flex; justify-content: center; align-items: center;">
                  <img src="${node.profilepic}" style="width: 32px; height: 32px; border-radius: 32px; margin-right: 2px;" />
                </div>`;
              }

              const span = `<div class="${toolClass}" style="z-index: 99">
                  <div style="display: flex; position: relative; color: #fff; width: 174px; height: 32px;">
                    <div style="margin-left: 0px;">
                      ${imagProfile}
                    </div>
                    <div style="display: flex; align-items: center; width: 90px; margin-left: 2px">
                      <div style="">
                        <div style="font-size: 11px; font-weight: 700; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 90px;">${node.fullname}</div>
                        <div style="font-size: 11px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 90px;">${node.team_name}</div>
                      </div>
                    </div>
                    <div style="display: flex; justify-content: center; align-items: center; margin: auto;">
                      <img src="${imageTooltip}" style="width:16px; height:16px; margin-right: 2px;" />
                      <div style="margin-top: 2px;">${node.directReport}</div>
                    </div>
                    <div style="position: absolute; bottom: -17.5px; left: 48%;">
                      <div style="border: 5px solid #000; border-color: #000000ae transparent transparent; width: 0px; height: 0px;"></div>
                    </div>
                  </div>
                </div>`;
              tableBody.innerHTML = span;
            });

            const tableRoot = tooltipEl.querySelector("table");

            // Remove old children
            while (tableRoot.firstChild) {
              tableRoot.firstChild.remove();
            }

            // Add new children
            tableRoot.appendChild(tableHead);
            tableRoot.appendChild(tableBody);
          }

          const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltip.caretX + "px";
          tooltipEl.style.top = positionY + tooltip.caretY + -56 + "px";
          tooltipEl.style.font = tooltip.options.bodyFont.string;
          tooltipEl.style.padding =
            tooltip.options.padding + "px " + tooltip.options.padding + "px";
        };
        options.plugins.tooltip = {
          enabled: false,
          position: "average",
          intersect: true,
          external: externalTooltipHandler,
        };
        // data.push({
        //   active: "N",
        //   activity_type: "Inactive",
        //   critical_area: "",
        //   critical_count: "",
        //   daily: 0,
        //   directReport: 0,
        //   email: "",
        //   feedback: 0,
        //   feedback_check: "N",
        //   firstname: "-",
        //   fullname: "-",
        //   inactive: "Y",
        //   insights_opened_check: "Y",
        //   lastname: "-",
        //   network_type: "Super Outer",
        //   passive: "N",
        //   profilepic: "",
        //   score: 0,
        //   shortname: "-",
        //   standard: [],
        //   length: 3,
        //   status: "inactive",
        //   super_feedback: 0,
        //   talent: "",
        //   team_id: "",
        //   team_name: "",
        //   weekly: 0,
        //   x: 100,
        //   y: 100,
        // });
        pointColor.push("transparent");
        pointRadius.push(0);
        this.myChart = new Chart(managerChart, {
          type: "bubble",
          data: {
            datasets: [
              {
                label: "",
                data: data,
                backgroundColor: pointColor,
                pointHoverRadius: pointRadius,
                radius: pointRadius,
                pointBorderWidth: 2,
              },
            ],
          },
          options: options,
        });
      }
    },
    createChartQuality() {
      var QualityChart = this.$refs.QualityChart;
      if (QualityChart) {
        // Ensure labels and data arrays are synchronized
        // Only show labels for data points that actually exist
        const syncedLabels = this.label.slice(0, this.weeklyData.length);
        
        this.myChart1 = new Chart(QualityChart, {
          type: "line",
          data: {
            labels: syncedLabels,//['Nov W1', 'Nov W2', 'Nov W3', 'Nov W4', 'Oct W1', 'Oct W2', 'Oct W3','Oct W4'],
            datasets: [
              {
                label: "Quality Score",
                data: this.weeklyData,//[65, 59, 80, 81, 56, 55, 40, 50],
                fill: false,
                borderColor: 'rgba(0, 0, 0, 0.1)',
                pointBorderColor: function (context) {
                  var index = context.dataIndex;
                  var value = context.dataset.data[index];
                  return value < 50 ? '#F44336' : value < 80 ? '#FBC02D' : '#66BB6A';
                },
                backgroundColor: 'white',
                tension: 0.1,
                borderWidth: 2,
                pointRadius: 4,
                pointBorderWidth: 3,
                pointHoverRadius: 8,
                pointHoverBorderWidth: 4,
              },
            ],
          },
          options: {
            plugins: {
              legend: {
                display: false
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'weekly averages',
                  font: {
                    family: 'Lato',
                    size: 11,
                    weight: 'bold',
                    lineHeight: 1.2,
                  },
                  color: 'rgba(0,0,0,0.70)'
                },
                grid: {
                  borderDash: [5, 5],
                  tickLength: 0
                },
                ticks: {
                  display: false
                }
              },
              y: {
                grid: {
                  display: false
                },
                display: false
              }
            }
          }
        });
      }
    },
    criticalAreadsCutOff(label) {
      let text = label.split(",");
      if (text.length < 2) {
        return label;
      } else if (text.length == 2) {
        return text.join(", ");
      } else {
        return `${text[1]}, ${text[2]} +${text.length - 2}`;
      }
    },
    routerLink(path, tab, query) {
      if (query) {
        this.$router.push({
          name: path,
          params: { tab: tab },
          query: { questionID: query },
        });
        this.$store.commit("dashboard/setOpenModalDashboard", true);
      } else {
        this.$router.push({ name: path, params: { tab: tab } });
      }
    },
    anchorTableLink() {
      var element = document.getElementById("scorecard");
      if (element) {
        const top = element.offsetTop;
        window.scrollTo(0, top + 130);
        this.$refs.table_anchor.scrollTop = 0 + 130;
      }
    },
    benchmarkBar(value) {
      return ((value * 120) / 100).toFixed();
    },
    arrayToPercentage(value) {
      const arr = [];
      let color = "bar-red";
      if (value > 70) {
        color = "bar-green";
      } else if (value > 40) {
        color = "bar-yellow";
      }
      for (let i = 0; i < 10; i++) {
        let status = (value - i * 10) * 1;
        let style = "";
        if (status > 10) {
          style = "";
        } else if (value - i * 10 > 0) {
          style = `opa-0${status * 1}`;
        } else {
          color = "";
        }
        arr.push(`${style} ${color}`);
      }
      return arr;
    },
    showPreviewData(row, column, event) {
      const item = row;
      this.userDetail = {};
      if (item.introduce) this.userDetail.introduce = item.introduce;
      if (item.culture_add_percentile) this.userDetail.culture_add_percentile = item.culture_add_percentile
      this.userDetail.large_pic = item.large_pic;
      this.userDetail.firstname = item.firstname;
      this.userDetail.lastname = item.lastname;
      this.userDetail.email = item.email;
      this.userDetail.dispteam = item.team_name;
      let colorCode = item.team_color ? item.team_color.replace(/#/g, "") : "";
      this.userDetail.team_color = colorCode;
      this.userDetail.team = item.team;
      this.userDetail.boss = item.boss;
      this.userDetail.tmp_boss = item.boss;
      this.userDetail.boss_pic = item.boss_pic;
      this.userDetail.dispboss = item.boss_name;
      this.userDetail.boss_firstname = item.boss_firstname;
      this.userDetail.boss_lastname = item.boss_lastname;
      this.userDetail.language = item.language;
      this.userDetail.user_type = item.user_type;
      this.userDetail.status = item.statusActive;
      this.userDetail.to_now = item.to_now;
      this.userDetail.streak_count = item.streak_count ? item.streak_count : 0;
      this.userDetail.super_feedback_count = item.super_feedback_count
        ? item.super_feedback_count
        : 0;
      this.userDetail.medal = item.medal ? item.medal : [];
      this.userDetail.coin = item.coin;
      this.userDetail.gem = item.gem;
      this.userDetail.house = item.house;
      this.userDetail.joined = item.joined ? item.joined : "";
      this.userDetail.joined_tooltips =
        item.joined_tooltips && item.joined_tooltips.length > 0
          ? item.joined_tooltips[0]
          : [];
      if (item.order_join) {
        let joinTotal = Object.keys(this.membersall).filter(
          (k) => this.membersall[k].order_join
        ).length;
        this.userDetail.joined_tooltips["percent"] = (
          ((joinTotal - item.order_join) / joinTotal) *
          100
        ).toFixed();
      }
      if (!this.coachingModalStatus) {
        this.$store.dispatch("people/getModalMemberData", item);
        this.modalPreviewDataStatus = true;
      }
    },
    closedModal() {
      this.$store.commit("people/setModalMemberData", []);
      this.modalPreviewDataStatus = !this.modalPreviewDataStatus;
    },
    getStrokeColor(value) {
      if (value >= 80) {
        return "#66BB6A";
      } else if (value >= 51 && value <= 79) {
        return "#FBC02D";
      } else if (value == '-') {
        return ''
      } else {
        return "#F44336";
      }
    },
    getStrokeDashOffset(value) {
      const totalCircumference = 62.83;
      const offset = totalCircumference * (1 - value / 100);
      return offset;
    },

    getReplyQuality(team_id) {
      if (this.dataQualitybyTeam[team_id]) {
        return this.dataQualitybyTeam[team_id].replyQuality;
      }
      return '0';
    },
    getBoxstyle(type, val) {

      if (type == 'Conversations') {
        if (val >= 60) {
          return 'box-green'
        } else if (val >= 50 && val < 60) {
          return 'box-yellow'
        } else {

          return 'box-red'
        }
      } else if (type == 'Peer-Feedback') {
        if (val >= 1) {
          return 'box-green'
        } else {
          return 'box-red'
        }
      } else if (type == 'Reviews-completed') {
        if (val >= 75) {
          return 'box-green'
        } else if (val >= 50 && val < 75) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'Goals-Progress') {
        if (val >= 75) {
          return 'box-green'
        } else if (val >= 50 && val < 75) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'Culture-Contribution') {
        if (val >= 75) {
          return 'box-green'
        } else if (val >= 50 && val < 75) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'DEBI') {
        if (val >= 60) {
          return 'box-green'
        } else if (val >= 40 && val < 60) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'Reply-Rate') {
        //if (this.standards_data.status) {
          if (this.standards_data.feedback_rate.active == 0 && this.standards_data.feedback_rate.passive == 0) {
          return 'box-gray'
          } else if (val >= this.standards_data.feedback_rate.active) {
            return 'box-green'
          } else if (val >= this.standards_data.feedback_rate.passive && val < this.standards_data.feedback_rate.active) {
            return 'box-yellow'
          } else {
            return 'box-red'
          }
        // } else {
        //   return 'box-gray'
        // }
      } else if (type == 'Opened') {
        //if (this.standards_data.status) {
          if (this.standards_data.open_rate.active == 0 && this.standards_data.open_rate.passive == 0) {
            return 'box-gray'
          }
          else if (val >= this.standards_data.open_rate.active) {
            return 'box-green'
          } else if (val >= this.standards_data.open_rate.passive && val < this.standards_data.open_rate.active) {
            return 'box-yellow'
          } else {
            return 'box-red'
          }
        // } else {
        //   return 'box-gray'
        // }

      }
    },
    getActionItemTooltip(criticalArea) {
      const tooltips = {
        "Recognition": "Recent weekly feedback indicates low recognition levels. Consider acknowledging direct reports' efforts more frequently.",
        "Satisfaction": "Monthly responses suggest work challenge levels are suboptimal for some direct reports. Reassess individual workloads and adjust task complexity as needed.",
        "Rel. Manager": "Weekly feedback indicates limited meaningful interactions with direct reports. Increase frequency of one-on-ones or individual check-ins.",
        "Company Alignment": "This month's feedback shows direct reports' performance towards company goals needs improvement. Clarify objectives and provide more personalized guidance.",
        "Happiness": "Daily pulse checks indicate low morale among direct reports. Investigate immediate causes and implement targeted mood-boosting initiatives.",
        "Ambassadorship": "This month's responses suggest the company isn't meeting direct reports' expectations. Address individual concerns and improve communication.",
        "Wellness": "Weekly surveys show high stress levels among direct reports. Monitor individual workload distribution and actively promote work-life balance.",
        "Feedback": "Weekly responses indicate direct reports desire more feedback. Increase frequency and quality of individual performance discussions.",
        "Personal Growth": "Monthly feedback suggests direct reports feel their growth is stagnating. Identify personalized skill development opportunities and create individual learning plans.",
        "Rel. Colleagues": "Monthly feedback indicates issues with peer support among direct reports. Encourage team collaboration and address any interpersonal challenges."
      };

      if (!criticalArea) return "No action items identified.";

      const areas = criticalArea.split(', ');
      const tooltipContent = areas.map(area => tooltips[area] || `Address issues related to ${area}.`).join('\n\n');

      return tooltipContent || "Address the identified action items.";
    },
    
    // Manager To-do List methods
    getTodoItems(email) {
      if (!this.managerTodoList || !this.managerTodoList[email]) {
        return [];
      }
      const selectedWeek = this.managerTodoSelectedWeek[email];
      if (!selectedWeek || !this.managerTodoList[email][selectedWeek]) {
        return [];
      }
      return this.managerTodoList[email][selectedWeek].todoList || [];
    },
    
getTodoCountStyle(email) {
      const totalCount = this.getTotalTodoCount(email);
      if (!totalCount || totalCount === 0) {
        return 'todo-count-empty';
      }
      // Use neutral style for all counts - avoid misleading color coding
      return 'todo-count-active';
    },
    
    getAvailableWeeks(email) {
      return this.managerTodoAvailableWeeks[email] || [];
    },

    getTotalTodoCount(email) {
      const weeks = this.getAvailableWeeks(email);
      if (!weeks.length || !this.managerTodoList[email]) return 0;
      
      let total = 0;
      weeks.forEach(week => {
        const weekData = this.managerTodoList[email][week];
        total += (weekData && weekData.todoList) ? weekData.todoList.length : 0;
      });
      return total;
    },

    getAllTodosByWeek(email) {
      const weeks = this.getAvailableWeeks(email);
      if (!weeks.length || !this.managerTodoList[email]) return [];
      
      return weeks
        .map(week => {
          const weekData = this.managerTodoList[email][week];
          const date = new Date(week);
          const options = { month: 'short', day: 'numeric' };
          return {
            weekDate: week,
            weekLabel: `Week of ${date.toLocaleDateString('en-US', options)}`,
            todos: (weekData && weekData.todoList) ? weekData.todoList : []
          };
        })
        .filter(week => week.todos.length > 0); // Only show weeks with items
    },

    getTodoTrend(email) {
      const weeks = this.getAvailableWeeks(email);
      if (weeks.length < 2) return 'none'; // Need at least 2 weeks for trend
      
      const latestCount = this.getTodoItems(email).length;
      
      // Calculate average of previous weeks (excluding latest)
      const previousWeeks = weeks.slice(1);
      let totalPrevious = 0;
      previousWeeks.forEach(week => {
        const weekData = this.managerTodoList[email] && this.managerTodoList[email][week];
        totalPrevious += (weekData && weekData.todoList) ? weekData.todoList.length : 0;
      });
      const avgPrevious = totalPrevious / previousWeeks.length;
      
      if (latestCount > avgPrevious + 0.5) return 'up';
      if (latestCount < avgPrevious - 0.5) return 'down';
      return 'same';
    },
    
    getSelectedWeekLabel(email) {
      const selectedWeek = this.managerTodoSelectedWeek[email];
      if (!selectedWeek) {
        return 'No data';
      }
      // Format date to "Week of Dec 16"
      const date = new Date(selectedWeek);
      const options = { month: 'short', day: 'numeric' };
      return `Week of ${date.toLocaleDateString('en-US', options)}`;
    },
    
    isLatestWeek(email) {
      const weeks = this.getAvailableWeeks(email);
      const selectedWeek = this.managerTodoSelectedWeek[email];
      if (!weeks.length || !selectedWeek) return true;
      return selectedWeek === weeks[0]; // weeks are sorted descending
    },
    
    hasPrevWeek(email) {
      const weeks = this.getAvailableWeeks(email);
      const selectedWeek = this.managerTodoSelectedWeek[email];
      if (!weeks.length || !selectedWeek) return false;
      const currentIndex = weeks.indexOf(selectedWeek);
      return currentIndex < weeks.length - 1;
    },
    
    prevWeek(email) {
      const weeks = this.getAvailableWeeks(email);
      const selectedWeek = this.managerTodoSelectedWeek[email];
      if (!weeks.length || !selectedWeek) return;
      const currentIndex = weeks.indexOf(selectedWeek);
      if (currentIndex < weeks.length - 1) {
        const prevWeekDate = weeks[currentIndex + 1];
        this.$store.dispatch('insightsManagers/selectManagerTodoWeek', { email, weekDate: prevWeekDate });
      }
    },
    
    nextWeek(email) {
      const weeks = this.getAvailableWeeks(email);
      const selectedWeek = this.managerTodoSelectedWeek[email];
      if (!weeks.length || !selectedWeek) return;
      const currentIndex = weeks.indexOf(selectedWeek);
      if (currentIndex > 0) {
        const nextWeekDate = weeks[currentIndex - 1];
        this.$store.dispatch('insightsManagers/selectManagerTodoWeek', { email, weekDate: nextWeekDate });
      }
    },
    
    goToLatest(email) {
      const weeks = this.getAvailableWeeks(email);
      if (weeks.length > 0) {
        this.$store.dispatch('insightsManagers/selectManagerTodoWeek', { email, weekDate: weeks[0] });
      }
    },
    getReviewCompleted(){
      const datalist=this.datalistSearchAll
      let memberbyteam=this.memberbyteam-1
      let dataQualitybyTeam=0
      let count=0
      //console.log('performance_review[i].completed',this.selectTeam)

      if(this.selectTeam=='all'||this.selectTeam==this.teamHeight){
        

        if(this.user_placeholder&&this.user_placeholder.completed){
          memberbyteam=Object.keys(this.membersall).length
          //console.log('this.user_placeholder',this.user_placeholder)
          dataQualitybyTeam=dataQualitybyTeam+this.user_placeholder.completed
        }else{
          memberbyteam=Object.keys(this.membersall).length-1
        }

      }
      
      
      for(let key in datalist){
        const val=datalist[key]
        if(this.dataQualitybyTeam[val.email] && this.dataQualitybyTeam[val.email].performance_review.completed){
          // console.log('val.email',this.dataQualitybyTeam[val.email])
          // console.log('this.dataQualitybyTeam[val.email].performance_review.completed',val.email,this.dataQualitybyTeam[val.email].performance_review.completed)
          dataQualitybyTeam=dataQualitybyTeam+Number(this.dataQualitybyTeam[val.email].performance_review.completed)
          
         
          
          
          
        }
          
      }
      
   

      return isNaN(dataQualitybyTeam/memberbyteam)?0:(dataQualitybyTeam/memberbyteam>100?"100":(dataQualitybyTeam/memberbyteam).toFixed())
    },
    
    // Generate mock trend data for the last 3 months
    handleProactivityTooltipShow() {
      // Debounce to prevent multiple calls
      if (this.proactivityTooltipTimer) {
        clearTimeout(this.proactivityTooltipTimer);
      }
      
      this.proactivityTooltipTimer = setTimeout(() => {
        const currentValue = this.adjustedProactivityRatingValue || 0;
        this.initializeProactivityTrendChart('main', currentValue);
      }, 150);
    },
    
    handlePsychologicalTooltipShow() {
      // Debounce to prevent multiple calls
      if (this.psychologicalTooltipTimer) {
        clearTimeout(this.psychologicalTooltipTimer);
      }
      
      this.psychologicalTooltipTimer = setTimeout(() => {
        const currentValue = this._activeOverview.psychologicalRatingValue || 0;
        this.initializePsychologicalTrendChart('main', currentValue);
      }, 150);
    },

    openProactivityModal() {
      this.showProactivityModal = true;
      // Initialize chart after modal is open
      this.$nextTick(() => {
        const currentValue = this.adjustedProactivityRatingValue || 0;
        this.initializeProactivityTrendChart('modal', currentValue);
      });
    },

    closeProactivityModal() {
      this.showProactivityModal = false;
    },

    openPsychologicalModal() {
      this.showPsychologicalModal = true;
      // Initialize chart after modal is open
      this.$nextTick(() => {
        const currentValue = this._activeOverview.psychologicalRatingValue || 0;
        this.initializePsychologicalTrendChart('modal', currentValue);
      });
    },

    closePsychologicalModal() {
      this.showPsychologicalModal = false;
    },
    
    async generateTrendData(currentValue, metricType = 'proactivity') {
      // TODO: ENGINEER VERIFICATION NEEDED - Chart Data Accuracy
      // ========================================================
      // This function now uses REAL historical data instead of mock data.
      // Please verify:
      // 1. The chart values match expectations for each month
      // 2. The trend direction (up/down) makes sense based on actual performance
      // 3. November's value should be similar to the "Overall Rating" if they measure overlapping periods
      // 4. Check console logs for detailed breakdown of what data is being calculated
      // 5. If Overall Rating = X but chart shows very different value, investigate the calculation
      //
      // Known issue to investigate: Peer feedback shows 100% in historical but 10% in current
      // This suggests different data sources or calculation methods between current vs historical
      //
      // IMPORTANT: This generates MONTHLY data (calendar months)
      // The currentValue parameter represents the LAST 30 DAYS (rolling window)
      // These are intentionally different time periods:
      // - Main score: Rolling 30-day window (e.g., June 24 - July 23)
      // - Trend chart: Calendar months (May, June, July partial)

      // Cache key based on current value and metric type
      const cacheKey = `${metricType}_${Math.round(currentValue)}`;

      // Check if we already have this data cached
      if (metricType === 'proactivity' && this.proactivityTrendData[cacheKey]) {
        return this.proactivityTrendData[cacheKey];
      } else if (metricType === 'psychological' && this.psychologicalTrendData[cacheKey]) {
        return this.psychologicalTrendData[cacheKey];
      }

      const months = this.getLastThreeMonths();
      let data = [];

      // For proactivity, use real historical data from Firebase
      if (metricType === 'proactivity') {
        // Fetch real historical data if we haven't already
        if (!this.historicalProactivityRatings) {
          try {
            this.historicalProactivityRatings = await this.$store.dispatch(
              'insightsManagers/getHistoricalProactivityRatings',
              {}
            );
          } catch (error) {
            console.error('Error fetching historical proactivity ratings:', error);
            this.historicalProactivityRatings = [];
          }
        }

        // Use the real historical data
        if (this.historicalProactivityRatings && this.historicalProactivityRatings.length === 3) {
          data = this.historicalProactivityRatings.map(month => month.rating);
          console.log('✅ Using real historical proactivity data:', this.historicalProactivityRatings);
        } else {

          
          // Fallback: if no data available, use current value for all months
          console.warn('⚠️ No historical proactivity data available, using current value for all months');
          console.warn('Current value:', currentValue);
          console.warn('historicalProactivityRatings:', this.historicalProactivityRatings);
          data = [currentValue, currentValue, currentValue];
        }
      } else if (metricType === 'psychological') {

             // Fetch real historical data if we haven't already
            if (!this.historicalProactivityRatings) {
              try {
                this.historicalProactivityRatings = await this.$store.dispatch(
                  'insightsManagers/getHistoricalProactivityRatings',
                  {}
                );
              } catch (error) {
                console.error('Error fetching historical proactivity ratings:', error);
                this.historicalProactivityRatings = [];
              }
            }
        // For psychological safety, use real historical data
        // Note: historicalProactivityRatings already contains psychological safety data
        if (this.historicalProactivityRatings && this.historicalProactivityRatings.length === 3) {
          data = this.historicalProactivityRatings.map(month => month.psychologicalSafety);
          console.log('✅ Using real historical psychological safety data:', this.historicalProactivityRatings.map(m => ({month: m.month, rating: m.psychologicalSafety})));
        } else {
          // Fallback: if no data available, use current value for all months
          console.warn('⚠️ No historical psychological safety data available, using current value for all months');
          console.warn('Current value:', currentValue);
          data = [currentValue, currentValue, currentValue];
        }
      }

      

      // Ensure all values are within 0-100 range
      const normalizedData = data.map(value => Math.max(0, Math.min(100, value)));

      const result = {
        labels: months,
        data: normalizedData
      };

      // Cache the result
      if (metricType === 'proactivity') {
        this.proactivityTrendData[cacheKey] = result;
      } else {
        this.psychologicalTrendData[cacheKey] = result;
      }
      return result;
    },
    
    // Get labels for the last 3 months
    getLastThreeMonths() {
      const months = [];
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const now = new Date();
      
      for (let i = 2; i >= 0; i--) {
        const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
        months.push(monthNames[date.getMonth()]);
      }
      
      return months;
    },
    
    // Get trend period label
    getTrendPeriodLabel() {
      const months = this.getLastThreeMonths();
      return `${months[0]} - ${months[2]} ${new Date().getFullYear()}`;
    },
    
    // Create mini trend chart
    createMiniTrendChart(canvasRef, trendData, color = '#6c30cc') {
      console.log('trendData',trendData.data)
      if (!canvasRef) return;
      
      // Use a consistent key based on the canvas ref name
      const chartKey = color === '#6c30cc' ? 'proactivity' : 'psychological';
      
      // Destroy existing chart if it exists
      if (this.trendCharts[chartKey]) {
        try {
          this.trendCharts[chartKey].destroy();
          this.trendCharts[chartKey] = null;
        } catch (e) {
          console.warn('Error destroying chart:', e);
        }
      }
      
      const ctx = canvasRef.getContext('2d');
      
      // Create new chart
      try {
        this.trendCharts[chartKey] = new Chart(ctx, {
        type: 'line',
        data: {
          labels: trendData.labels,
          datasets: [{
            data: trendData.data,
            borderColor: color,
            backgroundColor: `${color}20`,
            borderWidth: 2,
            fill: true,
            tension: 0.3,
            pointRadius: 3,
            pointBackgroundColor: color,
            pointBorderColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: true,
              mode: 'index',
              intersect: false,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              padding: 8,
              cornerRadius: 4,
              titleFont: {
                size: 11
              },
              bodyFont: {
                size: 11
              },
              callbacks: {
                label: function(context) {
                  return context.parsed.y + '/100';
                }
              }
            }
          },
          scales: {
            x: {
              display: true,
              grid: {
                display: false
              },
              ticks: {
                font: {
                  size: 10
                },
                color: '#666'
              }
            },
            y: {
              display: true,
              min: 0,
              max: 100,
              grid: {
                color: '#f0f0f0',
                drawBorder: false
              },
              ticks: {
                stepSize: 50,
                font: {
                  size: 9
                },
                color: '#999',
                padding: 4,
                callback: function(value) {
                  return value;
                }
              }
            }
          },
          layout: {
            padding: {
              left: 5,
              right: 10,
              top: 5,
              bottom: 5
            }
          }
        }
      });
      } catch (e) {
        console.error('Error creating chart:', e);
      }
    },
    
    // Initialize trend charts when tooltip is shown or modal is opened
    async initializeProactivityTrendChart(context, currentValue) {
      this.$nextTick(async () => {
        const canvasRef = context === 'modal'
          ? this.$refs.proactivityTrendChartModal
          : this.$refs.proactivityTrendChartMain;
        if (canvasRef) {
          const trendData = await this.generateTrendData(currentValue, 'proactivity');
          this.createMiniTrendChart(canvasRef, trendData, '#6c30cc');
        }
      });
    },
    
    // Initialize psychological safety trend chart
    async initializePsychologicalTrendChart(context, currentValue) {
      this.$nextTick(async () => {
        const canvasRef = context === 'modal'
          ? this.$refs.psychologicalTrendChartModal
          : this.$refs.psychologicalTrendChartMain;
        if (canvasRef) {
          console.log('currentValue',currentValue)
          const trendData = await this.generateTrendData(currentValue, 'psychological');
          console.log('trendData',trendData)
          this.createMiniTrendChart(canvasRef, trendData, '#2196f3');
        }
      });
    },

    /**
     * Render the responsiveness trend chart (compact stacked area)
     * Always renders area chart regardless of week count for consistency
     */
    renderResponsivenessTrendChart() {
      const trendData = this.managerTrendData;
      if (!trendData || !trendData.summary) return;

      // Always render area chart for compact integrated view
      this.renderResponsivenessAreaChart();
    },

    /**
     * Render stacked bar chart for manager responsiveness trends
     */
    renderResponsivenessAreaChart() {
      if (!this.$refs.responsivenessTrendChart) return;

      // Destroy existing chart instance
      if (this.responsivenessTrendChartInstance) {
        this.responsivenessTrendChartInstance.destroy();
        this.responsivenessTrendChartInstance = null;
      }

      const trendData = this.managerTrendData;
      if (!trendData || !trendData.labels || !trendData.datasets || trendData.datasets.length === 0) {
        return;
      }

      const ctx = this.$refs.responsivenessTrendChart.getContext('2d');

      this.responsivenessTrendChartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: trendData.labels,
          datasets: trendData.datasets.map((dataset, index) => {
            // In stacked bars: index 0 is bottom, last index is top
            // Round bottom corners of bottom bar, top corners of top bar
            const isBottom = index === 0;
            const isTop = index === trendData.datasets.length - 1;
            let borderRadius = 0;
            if (isBottom && isTop) {
              // Only one dataset - round all corners
              borderRadius = 3;
            } else if (isBottom) {
              borderRadius = { bottomLeft: 3, bottomRight: 3, topLeft: 0, topRight: 0 };
            } else if (isTop) {
              borderRadius = { topLeft: 3, topRight: 3, bottomLeft: 0, bottomRight: 0 };
            }
            
            return {
              label: dataset.label,
              data: dataset.data,
              absoluteData: dataset.absoluteData,
              backgroundColor: dataset.backgroundColor,
              borderColor: 'transparent',
              borderWidth: 0,
              borderRadius: borderRadius,
              borderSkipped: false,
              barPercentage: 0.7,
              categoryPercentage: 0.8,
            };
          }),
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                padding: 12,
                font: {
                  size: 11,
                  weight: '600',
                  family: 'Inter, sans-serif',
                },
                boxWidth: 7,
                boxHeight: 7,
                color: '#303133',
              },
            },
            tooltip: {
              backgroundColor: 'rgba(255, 255, 255, 0.98)',
              titleColor: '#303133',
              titleFont: {
                size: 13,
                weight: '600',
              },
              bodyColor: '#606266',
              bodyFont: {
                size: 12,
              },
              borderColor: '#e0e0e0',
              borderWidth: 1,
              padding: 12,
              boxPadding: 4,
              usePointStyle: true,
              itemSort: (a, b) => b.parsed.y - a.parsed.y,
              callbacks: {
                title: (tooltipItems) => {
                  if (tooltipItems.length === 0) return '';
                  const weekLabel = tooltipItems[0].label;
                  const dataIndex = tooltipItems[0].dataIndex;
                  const weeklyTotals = trendData.weeklyTotals || [];
                  const total = weeklyTotals[dataIndex] || 0;
                  return weekLabel + ' · ' + total + ' managers';
                },
                label: (context) => {
                  const label = context.dataset.label || '';
                  const percentage = Math.round(context.parsed.y || 0);
                  const absoluteData = context.dataset.absoluteData || [];
                  const absolute = absoluteData[context.dataIndex] || 0;
                  return ' ' + label + ': ' + percentage + '% (' + absolute + ')';
                },
              },
            },
          },
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
              },
              ticks: {
                font: {
                  size: 9,
                },
                color: '#909399',
                maxRotation: 0,
              },
            },
            y: {
              stacked: true,
              beginAtZero: true,
              max: 100,
              grid: {
                color: '#f5f5f5',
                drawBorder: false,
              },
              ticks: {
                font: {
                  size: 9,
                },
                color: '#909399',
                callback: (value) => value + '%',
                stepSize: 25,
              },
            },
          },
          // Show tooltip on last bar by default
          onHover: null,
        },
      });
    },
    
    /**
     * Render horizontal stacked bar chart for single-week data
     */
    renderResponsivenessSingleWeekChart() {
      if (!this.$refs.responsivenessSingleWeekChart) return;

      // Destroy existing chart instance
      if (this.responsivenessSingleWeekChartInstance) {
        this.responsivenessSingleWeekChartInstance.destroy();
        this.responsivenessSingleWeekChartInstance = null;
      }

      const trendData = this.managerTrendData;
      if (!trendData || !trendData.datasets || trendData.datasets.length === 0) {
        return;
      }

      const ctx = this.$refs.responsivenessSingleWeekChart.getContext('2d');
      const weekLabel = trendData.labels && trendData.labels[0] ? trendData.labels[0] : 'This Week';

      // Transform data for horizontal stacked bar
      const datasets = trendData.datasets.map((dataset) => ({
        label: dataset.label,
        data: [dataset.data[0] || 0],
        absoluteValue: dataset.absoluteData ? dataset.absoluteData[0] : 0,
        backgroundColor: dataset.backgroundColor,
        borderColor: dataset.borderColor,
        borderWidth: 1,
        borderRadius: 0,
      }));

      this.responsivenessSingleWeekChartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: [weekLabel],
          datasets: datasets,
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                padding: 15,
                font: {
                  size: 10,
                  weight: '500',
                  family: 'Nunito, sans-serif',
                },
                boxWidth: 6,
                boxHeight: 6,
                color: '#606266',
              },
            },
            tooltip: {
              backgroundColor: 'rgba(255, 255, 255, 0.98)',
              titleColor: '#303133',
              titleFont: {
                size: 12,
                weight: '600',
              },
              bodyColor: '#606266',
              bodyFont: {
                size: 11,
              },
              borderColor: '#e0e0e0',
              borderWidth: 1,
              padding: 10,
              boxPadding: 4,
              usePointStyle: true,
              callbacks: {
                title: () => {
                  const weeklyTotals = trendData.weeklyTotals || [];
                  const total = weeklyTotals[0] || 0;
                  return weekLabel + ' · ' + total + ' managers';
                },
                label: (context) => {
                  const label = context.dataset.label || '';
                  const percentage = Math.round(context.parsed.x || 0);
                  const absolute = context.dataset.absoluteValue || 0;
                  return ' ' + label + ': ' + percentage + '% (' + absolute + ')';
                },
              },
            },
          },
          scales: {
            x: {
              stacked: true,
              beginAtZero: true,
              max: 100,
              grid: {
                display: false,
              },
              ticks: {
                font: {
                  size: 10,
                },
                color: '#909399',
                callback: (value) => value + '%',
              },
            },
            y: {
              stacked: true,
              grid: {
                display: false,
              },
              ticks: {
                font: {
                  size: 11,
                  weight: '600',
                },
                color: '#303133',
              },
            },
          },
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
// Manager Responsiveness Integrated Chart Styles
.responsiveness-card {
  justify-content: space-between;
}

.responsiveness-integrated-chart {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.compact-chart-container {
  position: relative;
  width: 100%;
  height: 170px;
}

// Thin progress bar for Performance Boosts
.thin-progress-bar {
  height: 4px;
  background: #e8e8e8;
  border-radius: 2px;
  overflow: hidden;
  
  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #6C30CC, #9C6FE4);
    border-radius: 2px;
    transition: width 0.5s ease;
  }
}

.compact-chart-container canvas {
  width: 100% !important;
  height: 100% !important;
}

.chart-footer-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
}

.trend-badge-inline {
  font-size: 11px;
  font-weight: 500;
  color: #6C30CC;
  background: rgba(108, 48, 204, 0.08);
  padding: 4px 10px;
  border-radius: 12px;
}

.skeleton-chart-compact {
  height: 170px;
  background: linear-gradient(90deg, #f5f5f5 25%, #ebebeb 50%, #f5f5f5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.line-break {
  height: 1px;
  background: #e0e0e0;
}

.mb-20 {
  margin-bottom: 20px;
}

.skeleton-label {
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 4px;
}

.skeleton-chart {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 6px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

// Manager To-do List Styles
.todo-tooltip {
  padding: 8px 4px;
  max-height: 400px;
  overflow-y: auto;
  font-family: 'Nunito', sans-serif;
  
  // Custom scrollbar styling
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 4px;
    
    &:hover {
      background: #ccc;
    }
  }
}

.week-section {
  margin-bottom: 8px;
  padding: 0;
  
  &:not(:first-child) {
    padding-top: 12px;
    border-top: 1px dashed #e0e0e0;
  }
}

.week-header {
  font-size: 10px;
  font-weight: 800;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  padding-left: 8px;
}

.critical-header {
  font-size: 10px;
  font-weight: 800;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 10px;
  padding-left: 8px;
}

.todo-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 8px;
  border-radius: 6px;
  transition: background 0.2s;
  
  &:hover {
    background: #f9f9f9;
  }
}

.priority-badge {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  flex-shrink: 0;
  letter-spacing: 0.3px;
  margin-top: 3px;
  min-width: 45px;
  text-align: center;
  
  &.highest {
    background: #FEF2F2;
    color: #991B1B;
    border: 1px solid #F87171;
  }
  
  &.high {
    background: #FEF2F2;
    color: #DC2626;
    border: 1px solid #FECACA;
  }
  
  &.medium {
    background: #FFFBEB;
    color: #D97706;
    border: 1px solid #FDE68A;
  }
  
  &.low {
    background: #ECFDF5;
    color: #059669;
    border: 1px solid #A7F3D0;
  }
}

.todo-action {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  word-break: break-word;
  text-align: left;
  
  // Use :deep() to style elements inside v-html content
  :deep(a) {
    color: #6c30cc !important;
    font-weight: 700;
  }
  
  :deep(strong) {
    font-weight: 700;
  }
}

.critical-section {
  padding: 16px 4px 8px;
  border-top: 1px solid #f0f0f0;
}

.critical-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 8px;
}

.critical-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  color: #555;
  transition: all 0.2s;
  
  &:hover {
    border-color: #ccc;
    color: #333;
    background: #fafafa;
  }
}

.no-todos {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 16px 0;
}

.popover-note {
  font-size: 10px;
  color: #999;
  text-align: center;
  padding: 12px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  margin: 8px -4px -8px;
  border-radius: 0 0 4px 4px;
}

.todo-count {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  transition: all 0.2s;
  
  .todo-icon {
    flex-shrink: 0;
    opacity: 0.7;
  }
}

.todo-count-empty {
  background: #f5f5f5;
  color: #bbb;
}

.todo-count-active {
  background: #f0ebf8;
  color: #6c30cc;

  &:hover {
    background: #e8e0f4;
  }
}

.trend-arrow {
  font-size: 10px;
  margin-left: 2px;
  font-weight: 700;
}

.trend-up {
  color: #DC2626; // Red - more items than usual (needs attention)
}

.trend-down {
  color: #059669; // Green - fewer items than usual (improving)
}

.action-items-header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;
  padding: 0 4px;
  background: #6C30CC;
  color: white;
  font-size: 9px;
  font-weight: 700;
  border-radius: 8px;
}

.action-items-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #968FCC;
  border-radius: 8px;
}

.small-active-card {
  width: 100px;
  height: 85px;
  border-radius: 6px;
  text-align: center;
  box-sizing: border-box;
  background-color: #f4f4f4;
  margin-right: 6px;
}

.active-card {
  width: 185px;
  height: 85px;
  border-radius: 6px;
  text-align: center;
  box-sizing: border-box;
  background-color: #f4f4f4;
}

.txt-percent {
  color: #363636;
  margin-left: 6px;
  font-size: 14px;
}

.txt-percent.green {
  color: #27bc6c;
}

.txt-percent.yellow {
  color: #fbc02d;
}

.txt-percent.red {
  color: #f44336;
}

.txt-detail-percent {
  font-size: 11px;
  opacity: 0.5;
  color: #000;
}

.txt-head-card {
  font-size: 28px;
  display: inline-block;
}

.top-title {
  text-align: center;
  margin-bottom: -9px;
  z-index: 10;
  font-weight: 700;

  >div {
    padding: 4px;
    background-color: rgba(#000, 0.02);
    border-radius: 3px;
    margin: 0 8px;
    font-size: 12px;
    color: #454545;
  }
}

.txtDataList {
  font-size: 12px;
  color: #3c3c3c;
}

.text-modal {
  font-size: 13px;
  color: #4a4a4a;
}

.txtName,
.txtTeam {
  color: #3c3c3c;
  width: 175px;
}

.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}

.txtOption1 {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  height: 40px;
  display: inline-block;
}

.menu-option-style {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.chart-container {
  position: relative;
  height: 190px;
  margin-top: 16px;
  padding: 16px 16px 32px 32px;
  background-color: #00000002;
}

.site-text {
  transform: rotate(-90deg);
  width: 120px;
  position: absolute;
  margin-top: 113px;
  margin-left: -32px;
}

.imgProfile {
  width: 36px;
  height: 36px;
  border-radius: 36px;
}

.profilepic {
  position: relative
}

.profilepic .noti-count {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color: #685D79;
  color: white;
  font-family: 'Lato';
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
}

.profilepic .report-count {
  position: absolute;
  min-width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color: #685D79;
  color: white;
  font-family: 'Lato';
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  cursor: help;
  transition: all 0.2s;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  &:hover {
    transform: scale(1.1);
  }
}

.profilepic .report-count-orange {
  background-color: #D97706;
  font-weight: 700;
}

.profilepic .report-count-red {
  background-color: #DC2626;
  font-weight: 700;
}

.activity-status {
  font-size: 11px;
  font-weight: 700;
  border-radius: 4px;
  padding: 1px 4px 0;
}

.activity-status.active {
  color: #43500d;
  background-color: rgba(#66bb6a, 0.15);
}

.activity-status.passive {
  color: #745301;
  background-color: rgba(#fbc02d, 0.15);
}

.activity-status.in-Active {
  color: #6e1d17;
  background-color: rgba(#f44336, 0.15);
}

.span-last-30-day {
  border-radius: 2px;
  background-color: rgba(#000, 0.06);
  color: #6c30cc;
  font-size: 11px;
  font-weight: 700;
  padding: 8px 12px;
  margin: 0 0 0 14px;
}

.report-container {
  display: grid;
  grid-template-columns: 416px 290px 190px;
  align-items: stretch;

  > div {
    display: flex;
    flex-direction: column;
    
    .box-card-border {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .text-header {
    font-size: 15px;
    font-weight: 700;
  }

  .text-green {
    color: #1ac362;
  }

  .text-red {
    color: #f44336;
  }

  .text-gray {
    color: #999;
  }

  .title {
    font-size: 12px;
    font-weight: 700;
    color: #000;
  }

  .box-card-border {
    box-shadow:
      0px 0.3px 0.9px rgba(0, 0, 0, 0.008),
      0px 0.8px 2.1px rgba(0, 0, 0, 0.012),
      0px 1.5px 4px rgba(0, 0, 0, 0.015),
      0px 2.7px 7.1px rgba(0, 0, 0, 0.018),
      0px 5px 13.4px rgba(0, 0, 0, 0.022),
      0px 12px 32px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    padding: 16px;
    margin-top: 8px;
  }

  .box-card-border1 {
    box-shadow: 0px 2px 4px #00000029;
    border-radius: 4px;
    padding: 21px 16px 16px;
    margin-top: 8px;
    min-height: calc(169px - 40px);
  }

  .grid-3-auto {
    display: grid;
    grid-template-columns: repeat(3, calc((100% / 3) - ((24px * 2) / 3)));
    gap: 24px;

    .status-box {
      border-radius: 4px;
      height: calc(69px - 16px);
      padding: 8px 12px;

      .circle {
        width: 24px;
        height: 24px;
        border-radius: 24px;
        object-fit: cover;
      }
    }
  }

  .label-change {
    font-size: 11px;
    font-weight: 700;
    margin-top: 4px;
    margin-left: 3px;
    width: 44px;
    white-space: nowrap;
  }

  .bar-contariner {
    .bar {
      border-radius: 6px;
      width: 6px;
      height: 32px;
      margin-right: 2px;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }

    .bar-green {
      background-color: #35d077;
    }

    .bar-yellow {
      background-color: #fbc02d;
    }

    .bar-red {
      background-color: #f44336;
    }
  }

  .benchmark {
    width: 46px;
    text-align: center;
    padding: 10px 0 8px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    border-radius: 4px;
    margin-right: 16px;
    background-color: #e0e0e0;
  }

  .benchmark.green {
    background-color: #35d077;
  }

  .benchmark.red {
    background-color: #f44336;
  }

  .benchmark.yellow {
    background-color: #fbc02d;
  }

  .point-bar {
    width: 150px;
    border-radius: 6px;
    height: 6px;
    background-color: rgba($color: #000000, $alpha: 0.2);

    .value {
      position: relative;
      border-radius: 6px;
      height: 6px;
      background: #35d077;
    }

    .value.benchmark {
      position: relative;
      height: 6px;
      top: -6px;
      background: transparent;

      &::before {
        content: "";
        position: absolute;
        right: -1px;
        top: -3px;
        border-right: 2px solid #6c30cc;
        height: 12px;
      }
    }
  }

  .gray-icon-32 {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background-color: #b4b4b4;
    object-fit: cover;
  }

  .score-box {
    width: 38px;
    height: 32px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    color: #fff;
    border-radius: 5px;
    margin-right: 12px;
    background-color: #e0e0e0;
  }

  .score-box.yellow {
    background-color: #fbc02d;
  }

  .score-box.green {
    background-color: #35d077;
  }

  .score-box.red {
    background-color: #f44336;
  }

  .score-box.cursor-pointer {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .score-box.cursor-pointer:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .score-box {
    transition: all 0.3s ease;
  }

  .score-box.updating {
    opacity: 0.7;
    transform: scale(0.98);
  }

  .point-bar .value {
    transition: width 0.3s ease, background-color 0.3s ease;
  }
}

.divTable .status {
  width: 16px;
  height: 16px;
  margin-bottom: 3px;
  vertical-align: middle;
}

.divTable .progress-wrapper {
  position: relative;
  width: 26px;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
}

.divTable .score-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 500;
  color: #000;
  text-align: center;
  z-index: 2;
  text-align: center;
  line-height: 24px;
  /* Adjust this if you change the .progress-wrapper dimensions */
  white-space: nowrap;
  /* Prevents the label from wrapping to the next line */
}

.box-card-border .score-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 500;
  color: #000;
  text-align: center;
  z-index: 2;
  text-align: center;
  line-height: 24px;
  /* Adjust this if you change the .progress-wrapper dimensions */
  white-space: nowrap;
  /* Prevents the label from wrapping to the next line */
}

.score-label .main {
  font-size: 42px;
  line-height: 42px;
}

.score-label .description {
  line-height: 18px;
}

.box-card-border .progress-wrapper {
  position: relative;
  width: 135px;
  height: 135px;
  display: inline-block;
  vertical-align: middle;
}

.box-card-table {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000001F;
  border-radius: 6px;
  opacity: 1;
  min-height: 53px;
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.box {
  border-radius: 6px;

  top: 1326px;
  left: 546px;
  width: 36px;
  height: 28px;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
}

.box-red {
  background: #fdd9d7 0% 0% no-repeat padding-box;

}

.box-yellow {
  background: #fef2d5 0% 0% no-repeat padding-box;

}

.box-green {
  background: #e0f1e1 0% 0% no-repeat padding-box;

}

.box-gray {
  background: #e7e7e7 0% 0% no-repeat padding-box;

}

.line-break {
  height: 1px;
  background: #e0e0e0;
  border: none;
  opacity: 1;
}

.section-break {
  height: 20px;
  width: 1px;
  background-color: rgba(#000, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}

.no-results {
  text-align: center;
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.filter-criteria-toolbar {
  background-color: #f2edfa;
  border-left: 4px solid #6C30CC;
  border-radius: 4px;
  padding: 12px 16px;
  width: 860px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-criteria-toolbar .flex-center {
  display: flex;
  align-items: flex-start;
}

.filter-criteria-toolbar .filter-icon {
  color: #6C30CC;
  font-size: 18px;
  margin-right: 12px;
  margin-top: 3px;
}

.filter-criteria-toolbar .filter-details {
  flex: 1;
}

.filter-criteria-toolbar .filter-title {
  font-weight: 700;
  font-size: 14px;
  // margin-bottom: 4px;
  color: #333;
}

.filter-criteria-toolbar .filter-description {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.filter-criteria-toolbar .edit-criteria-btn {
  color: #999;
  padding: 0;
  font-size: 16px;
  margin-left: 8px;
  margin-top: -2px;
}

.filter-criteria-toolbar .edit-criteria-btn:hover {
  color: #333;
}

.pagination .results-status {
  margin-left: 8px;
  font-size: 13px;
  color: #999;
}

.pagination .text-center {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #666;
}

/* Enhanced Tooltip Styles */
.tooltip-breakdown {
  background: #fff;
  border-radius: 8px;
  padding: 0;
  max-width: 380px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  font-family: 'Lato', sans-serif;
}

.tooltip-header {
  background: linear-gradient(135deg, #6c30cc 0%, #8e44ad 100%);
  color: white;
  padding: 16px 20px;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tooltip-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.tooltip-score {
  font-size: 20px;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 20px;
}

.breakdown-section {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.breakdown-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}

.calculation-note {
  font-size: 12px;
  color: #666;
  font-style: italic;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: rgba(108, 48, 204, 0.05);
  border-radius: 4px;
  border-left: 3px solid #6c30cc;
}

.component-item {
  margin-bottom: 16px;
}

.component-item:last-child {
  margin-bottom: 0;
}

.component-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.component-name {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.performance-indicator-header {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.performance-indicator-header.good {
  background: rgba(102, 187, 106, 0.2);
  color: #2e7d32;
}

.performance-indicator-header.needs-attention {
  background: rgba(251, 192, 45, 0.2);
  color: #f57c00;
}

.performance-indicator-header.poor {
  background: rgba(244, 67, 54, 0.2);
  color: #c62828;
}

.component-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.bar-track {
  flex: 1;
  background: #ebebeb;
  border-radius: 4px;
  height: 8px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.component-value {
  font-size: 12px;
  font-weight: 700;
  color: #333;
  flex-shrink: 0;
  min-width: 40px;
  text-align: right;
}

.performance-indicator {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.performance-indicator.good {
  background: rgba(102, 187, 106, 0.2);
  color: #2e7d32;
}

.performance-indicator.needs-attention {
  background: rgba(251, 192, 45, 0.2);
  color: #f57c00;
}

.performance-indicator.poor {
  background: rgba(244, 67, 54, 0.2);
  color: #c62828;
}

.component-description {
  font-size: 11px;
  color: #666;
  font-style: italic;
}

.improvement-section {
  padding: 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.improvement-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.improvement-list {
  margin: 0;
  padding-left: 20px;
  color: #555;
}

.improvement-list li {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 6px;
}

.improvement-list li:last-child {
  margin-bottom: 0;
}

/* Trend Section Styles */
.trend-section {
  padding: 20px;
  background: #fafbfc;
  border-bottom: 1px solid #e9ecef;
}

.trend-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.trend-chart-container {
  position: relative;
  height: 120px;
  width: 100%;
  margin-bottom: 8px;
  background: white;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.trend-chart {
  width: 100% !important;
  height: 100% !important;
}

.trend-legend {
  text-align: center;
  font-size: 11px;
  color: #666;
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trend-note {
  font-size: 10px;
  color: #999;
  font-style: italic;
}

.trend-period {
  font-weight: 500;
}

/* Toggle Control Styles */
.tracking-toggle-section {
  padding: 16px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  border-radius: 0 0 8px 8px;
}

.toggle-container {
  margin-bottom: 8px;
}

.toggle-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.toggle-checkbox {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  background: #ccc;
  border-radius: 24px;
  margin-right: 12px;
  transition: background 0.2s ease;
}

.toggle-slider::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-checkbox:checked + .toggle-slider {
  background: #6c30cc;
}

.toggle-checkbox:checked + .toggle-slider::before {
  transform: translateX(20px);
}

.toggle-text {
  flex: 1;
}

.toggle-description {
  font-size: 11px;
  color: #666;
  line-height: 1.4;
  margin-left: 56px;
}

/* Modal styles */
.breakdown-info-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #409eff;
  margin-left: 8px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.breakdown-info-btn:hover {
  background-color: #ecf5ff;
  color: #337ecc;
}

.breakdown-info-btn i {
  font-size: 16px;
}

.modal-breakdown {
  background: #fff;
  border-radius: 8px;
  padding: 0;
  max-height: 85vh;
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(90deg, #6C30CC, #9C6FE4);
  color: white;
  padding: 18px 24px;
  position: relative;
}

.modal-header::before {
  display: none;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.score-display {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.score-number {
  font-size: 32px;
  font-weight: 900;
  line-height: 1;
}

.score-denominator {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.7;
}

.score-context {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.score-label {
  font-size: 15px;
  font-weight: 600;
  opacity: 0.95;
}

.score-status-container {
  margin-left: auto;
}

.score-status {
  font-size: 13px;
  padding: 5px 14px;
  border-radius: 20px;
  font-weight: 600;
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.score-status.excellent {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.score-status.good {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.score-status.needs-improvement {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.score-status.poor {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Section header styling */
.section-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}

.breakdown-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0 0 6px 0;
}

.calculation-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #f8f8fa;
  padding: 8px 12px;
  border-radius: 4px;
  border-left: 3px solid #6C30CC;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.calculation-note i {
  color: #6C30CC;
  margin-top: 2px;
  flex-shrink: 0;
}

/* Component items styling */
.component-item {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 14px 16px;
  margin-bottom: 10px;
}

.component-item:last-child {
  margin-bottom: 0;
}

.component-item--hoverable {
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.component-item--hoverable:hover {
  border-color: #6C30CC;
}

.component-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.component-name {
  font-weight: 700;
  color: #333;
  font-size: 13px;
}

.performance-indicator-header {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.component-description {
  font-size: 11px;
  color: #999;
  margin-top: 6px;
  line-height: 1.3;
}

/* Two-column layout for modal content */
.modal-content-grid {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 24px;
  padding: 20px 24px 24px 24px;
  min-height: 350px;
  max-height: calc(85vh - 120px);
  background: #f8f8fa;
  align-items: start;
}

.components-column {
  overflow-y: auto;
  max-height: calc(85vh - 160px);
  padding-right: 6px;
}

.breakdown-section {
  background: transparent;
  padding: 0;
}

.chart-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  height: fit-content;
  max-height: calc(85vh - 160px);
}

.chart-column .trend-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-column .trend-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 14px;
  text-align: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.chart-column .trend-chart-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  max-height: 220px;
  background: #fafbfc;
  border-radius: 4px;
  margin-bottom: 12px;
}

.chart-column .trend-chart {
  max-width: 100%;
  max-height: 200px;
}

.chart-column .trend-legend {
  text-align: center;
  font-size: 11px;
  color: #999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}

.trend-period {
  font-weight: 600;
  color: #666;
}

.trend-note {
  font-style: italic;
  color: #bbb;
}

/* Responsive design for smaller screens */
@media (max-width: 1024px) {
  .modal-content-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .chart-column {
    order: -1;
    min-height: 200px;
  }

  .components-column {
    max-height: none;
  }
}

/* Peer Feedback Tooltip - Minimal */
.peer-feedback-tooltip {
  padding: 8px 10px;
  min-width: 280px;
  max-width: 300px;
}

.pf-header {
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 8px;
  text-align: center;
}

.pf-loading {
  padding: 15px 0;
  text-align: center;
}

.pf-heatmap {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
}

.pf-month {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.pf-month-label {
  font-size: 8px;
  font-weight: 600;
  color: #9CA3AF;
  letter-spacing: 0.3px;
}

.pf-circles {
  display: flex;
  gap: 2px;
  align-items: center;
}

.pf-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #E5E7EB;
  background-color: #FFFFFF;

  &.filled {
    background-color: #6C30CC;
    border-color: #6C30CC;
  }
}

.pf-count {
  font-size: 10px;
  font-weight: 600;
  color: #374151;
}
</style>

<style lang="scss">
/* Modal global styles */
.breakdown-modal .el-dialog {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.breakdown-modal .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.breakdown-modal .el-dialog__body {
  padding: 0;
}

.breakdown-modal .el-dialog__title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.breakdown-modal .el-dialog__close {
  font-size: 16px;
  color: #999;
  transition: color 0.15s ease;
}

.breakdown-modal .el-dialog__close:hover {
  color: #333;
}

/* Voice Safety Tooltip */
.voice-safety-tooltip {
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  border-radius: 6px !important;
  padding: 0 !important;
}

.voice-safety-tooltip .popper__arrow {
  border-right-color: #e8e8e8 !important;
}

.vs-tooltip-title {
  font-size: 12px;
  font-weight: 700;
  color: #333;
  padding: 10px 14px 8px;
  border-bottom: 1px solid #f0f0f0;
}

.vs-tooltip-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 14px;
  gap: 24px;
}

.vs-tooltip-row:last-child {
  padding-bottom: 10px;
}

.vs-tooltip-label {
  font-size: 12px;
  color: #666;
}

.vs-tooltip-value {
  font-size: 13px;
  font-weight: 700;
  color: #333;
}

.vs-tooltip-bar {
  display: flex;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  margin: 2px 14px;
  background: #f0f0f0;
}

.vs-tooltip-bar-anon {
  background: #F7B924;
  height: 100%;
  transition: width 0.2s ease;
}

.vs-tooltip-bar-open {
  background: #3AC47D;
  height: 100%;
  transition: width 0.2s ease;
}

#insightsManagers2 .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f5f580;
  cursor: pointer;

  .buttom-detail-image {
    opacity: 1;
  }
}

#menuDropdown .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}

#menuDropdownType .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}

#coachingModalStatus {
  .el-dialog__header {
    padding-top: 32px;
    padding-left: 40px;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }
  }

  .el-dialog__body {
    padding: 0;

    .profile {
      padding: 12px 40px 16px;
      height: 45px;
    }

    .table {
      padding: 12px 12px 24px 40px;
      box-shadow: inset 0px 5px 3px 0px #0000001c;

      .score {
        width: 60px;
        margin: auto;
        padding-left: 4px;
      }

      .circle-score {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        margin-top: 6px;
        margin-right: 4px;
      }

      .circle-red {
        background-color: #f44336;
      }

      .circle-green {
        background-color: #66bb6a;
      }

      .circle-yellow {
        background-color: #fbc02d;
      }
    }
  }
}

#managerClassificationSettingsModalStatus {
  .el-dialog__header {
    padding-top: 32px;
    padding-left: 40px;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }
  }

  .el-dialog__body {
    padding: 22px 40px 40px;

    .input-size {
      width: 74px;
      position: relative;
    }

    .title-text-input {
      font-size: 16px;
      color: #000;
      margin-right: 12px;
    }

    .percentag-text {
      position: absolute;
      top: 11px;
      right: 12px;
      font-weight: 700;
      color: #4a4a4a;
    }

    .percentag-text.disabled {
      opacity: 0.5;
    }
  }
}

#insightsManagerTable {
  .labelTableStyle.is-leaf {
    font-size: 12px;
    font-weight: 500;
  }

  .labelTableStyle.is-leaf {
    padding-left: 0;
    padding-right: 0;
  }

  .labelTableStyle.SortStyle {
    padding-left: 0;
    padding-right: 0;
  }

  .labelTableStyle {
    font-size: 12px;
  }

  .el-table__header {
    border: 1px solid #e0e0e0;
    border-width: 0 0 1px 0;

    th {
      padding-bottom: 6px;
    }
  }

  td {
    padding-bottom: 0px;
  }

}

#insightsManagerTable.el-table .el-table__cell {
  padding: 6px 0 !important;
}

#insightsManagerTable .el-table__body-wrapper {
  padding-top: 12px;
}

#insightsManagers2 {
  .el-table .cell {
    padding: 0 5px;
  }
}

.section-break {
  height: 20px;
  width: 1px;
  background-color: rgba(#000, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
</style>

<style lang="scss">
// Unscoped styles for popover content (rendered outside component scope)
.todo-tooltip {
  .todo-action {
    a {
      color: #6c30cc !important;
      font-weight: 700 !important;
      text-decoration: none !important;
      
      &:hover {
        opacity: 0.8;
      }
    }
    
    strong {
      font-weight: 700;
    }
  }
}
</style>
